
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73TCo", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $21316eb17a577fc6$export$461c2ed3163c74ff);

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $2eb96 = parcelRequire("2eb96");
parcelRequire("h3wYQ");
var $cQbTj = parcelRequire("cQbTj");
var $f8AFM = parcelRequire("f8AFM");

var $8jJQh = parcelRequire("8jJQh");

var $dF1Nh = parcelRequire("dF1Nh");

var $24JrB = parcelRequire("24JrB");

var $7LK1f = parcelRequire("7LK1f");

var $61vzn = parcelRequire("61vzn");

var $hAnPj = parcelRequire("hAnPj");

var $i5Ioa = parcelRequire("i5Ioa");

var $cOQgu = parcelRequire("cOQgu");
var $dKIZZ = parcelRequire("dKIZZ");
var $gz8ZY = parcelRequire("gz8ZY");

var $2tne1 = parcelRequire("2tne1");

var $2WkeQ = parcelRequire("2WkeQ");

var $koDo7 = parcelRequire("koDo7");

var $g2WJx = parcelRequire("g2WJx");
parcelRequire("c5zvz");
var $5DQLv = parcelRequire("5DQLv");

var $liCZ6 = parcelRequire("liCZ6");
const $21316eb17a577fc6$export$461c2ed3163c74ff = ()=>{
    const { nav4AdminOptedIn: isSiteWideNav4Enabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    (0, $cOQgu.useAddUFOCustomDataForNavType)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Disco'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2eb96.ConditionalCreateSpaceDrawer), null), (isSiteWideNav4Enabled || isNav4DisplayedToUser) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2tne1.Nav4FeedbackCollectorModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2WkeQ.MisalignedNavVersionsFlag), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).MIGRATIONS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Migrations'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f8AFM.ConditionalImportContentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cQbTj.ConditionalImportContentDrawer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ECOSYSTEM,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Ecosystem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8jJQh.ForgeGlobalKeyboardShortcuts), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ADMIN_EXPERIENCE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-AdminExperience'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dF1Nh.StorageEnforcement), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION,
        attributes: {
            errorBoundaryId: 'GlobalComponents-FlywheelAdoption'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $24JrB.OnboardingQuickstart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g2WJx.ModernizeModal), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthLuna'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $koDo7.TrialPlanComparisonModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5DQLv.StandardToPremiumModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7LK1f.RovoVideoModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.TrialFlags), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hAnPj.LazyRestrictionsDialogMountPoint), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $liCZ6.ModernizeChangeboarding), null)), isNav4DisplayedToUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i5Ioa.ProgressBar), {
        isNav4: true
    })));
};

});
parcelRegister("2eb96", function(module, exports) {

$parcel$export(module.exports, "ConditionalCreateSpaceDrawer", () => $60b070effa9833b5$export$8b3b261467ad7423);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $bAyaS = parcelRequire("bAyaS");

const $60b070effa9833b5$var$CreateSpaceDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8t-EL",
    name: "CreateSpaceDrawerLoader",
    loader: async ()=>(await (parcelRequire("bAx9p"))).CreateSpaceDrawer
});
const $60b070effa9833b5$export$8b3b261467ad7423 = ()=>{
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    return shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
};

});
parcelRegister("bAyaS", function(module, exports) {

$parcel$export(module.exports, "useCreateSpaceStore", () => $8eabddf4fe78ba91$export$5642c413017336a4);
$parcel$export(module.exports, "useShouldRenderDrawer", () => $8eabddf4fe78ba91$export$34596812152477bc);
$parcel$export(module.exports, "useCreateSpaceStoreActions", () => $8eabddf4fe78ba91$export$ad3d638eaaafd693);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $4ZoIm.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $iFWZA.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $iFWZA.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $iFWZA.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $iFWZA.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);

});

parcelRegister("bAx9p", function(module, exports) {

let $86fcc58b6df9cc3a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $86fcc58b6df9cc3a$var$load("4o7bO"),
    $86fcc58b6df9cc3a$var$load("12s7O"),
    $86fcc58b6df9cc3a$var$load("8oWxD"),
    $86fcc58b6df9cc3a$var$load("6ZETc"),
    $86fcc58b6df9cc3a$var$load("hzK1f"),
    $86fcc58b6df9cc3a$var$load("fqrMn"),
    $86fcc58b6df9cc3a$var$load("fYi1a"),
    $86fcc58b6df9cc3a$var$load("bjzRn"),
    $86fcc58b6df9cc3a$var$load("8mzoy"),
    $86fcc58b6df9cc3a$var$load("7a9CL"),
    $86fcc58b6df9cc3a$var$load("ivQYH"),
    $86fcc58b6df9cc3a$var$load("8pE8S"),
    $86fcc58b6df9cc3a$var$load("9Bu2S"),
    $86fcc58b6df9cc3a$var$load("42vdC"),
    $86fcc58b6df9cc3a$var$load("P5iE2"),
    $86fcc58b6df9cc3a$var$load("atyNV")
]).then(()=>parcelRequire('1tDKi'));

});


parcelRegister("h3wYQ", function(module, exports) {

$parcel$export(module.exports, "ConditionalImportContentDrawer", () => (parcelRequire("cQbTj")).ConditionalImportContentDrawer);
$parcel$export(module.exports, "ConditionalImportContentModal", () => (parcelRequire("f8AFM")).ConditionalImportContentModal);
$parcel$export(module.exports, "ImportContentButton", () => (parcelRequire("gKGjM")).ImportContentButton);

var $cQbTj = parcelRequire("cQbTj");

var $f8AFM = parcelRequire("f8AFM");

var $gKGjM = parcelRequire("gKGjM");

});
parcelRegister("cQbTj", function(module, exports) {

$parcel$export(module.exports, "ConditionalImportContentDrawer", () => $8584efcc44eb8061$export$5aeeed7cf265bb36);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $5IN3L = parcelRequire("5IN3L");

const $8584efcc44eb8061$var$ImportContentDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R258E",
    name: "ImportContentDrawerLoader",
    loader: async ()=>(await (parcelRequire("iEXHN"))).ImportContentDrawer
});
const $8584efcc44eb8061$export$5aeeed7cf265bb36 = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    return importContentState.shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8584efcc44eb8061$var$ImportContentDrawerLoader, {
        isImportingContent: importContentState.showImportContentDrawer,
        setIsImportingContent: importContentActions.setShowImportContentDrawer,
        contentType: importContentState.contentType
    }) : null;
};

});
parcelRegister("5IN3L", function(module, exports) {

$parcel$export(module.exports, "ImportContentWorkflowContext", () => $c73c161a517b87e3$export$7805c3dc7bda328d);
$parcel$export(module.exports, "ImportContentWorkflowContextProvider", () => $c73c161a517b87e3$export$4261666d8e0efef2);
$parcel$export(module.exports, "useImportContentStore", () => $c73c161a517b87e3$export$316a7de2e8141cc8);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $gwFzn = parcelRequire("gwFzn");

var $8uc8a = parcelRequire("8uc8a");

var $27ffu = parcelRequire("27ffu");

var $dzqet = parcelRequire("dzqet");
const $c73c161a517b87e3$export$390f32400eaf98c9 = (0, $4ZoIm.createStore)({
    initialState: {
        showImportContentDrawer: false,
        shouldRenderDrawer: false,
        showImportContentModal: false,
        shouldRenderModal: false,
        shouldRenderMiroTokenModal: false,
        contentType: (0, $dzqet.ContentType).NOTION
    },
    actions: {
        setShowImportContentDrawer: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentDrawer: value
                });
            },
        setShouldRenderDrawer: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderDrawer: value
                });
            },
        setShowImportContentModal: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentModal: value
                });
            },
        setShouldRenderModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderModal: value
                });
            },
        setShouldRenderMiroTokenModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderMiroTokenModal: value
                });
            },
        setContentType: (value)=>({ setState: setState })=>{
                setState({
                    contentType: value
                });
            }
    },
    name: 'importContentStore'
});
const $c73c161a517b87e3$export$7805c3dc7bda328d = /*#__PURE__*/ (0, $gwFzn.createContext)({
    authProviderError: '',
    setAuthProviderError: ()=>{},
    hasSubpages: false,
    setHasSubpages: ()=>{},
    dropzoneCancelFnRef: {
        current: null
    },
    browserCancelFnRef: {
        current: null
    },
    isUploadingFile: false,
    setIsUploadingFile: ()=>{},
    isStartingImport: false,
    setIsStartingImport: ()=>{},
    fileNameDisplay: '',
    setFileNameDisplay: ()=>{},
    fileSizeBytes: 0,
    setFileSizeBytes: ()=>{},
    filestoreId: '',
    setFilestoreId: ()=>{},
    collectionId: '',
    setCollectionId: ()=>{},
    shouldMapNotionMembers: true,
    setShouldMapNotionMembers: ()=>{},
    shouldRenderCloseDrawerModal: false,
    setShouldRenderCloseDrawerModal: ()=>{},
    shouldRenderIntegrationTokenModal: false,
    setShouldRenderIntegrationTokenModal: ()=>{},
    integrationToken: '',
    setIntegrationToken: ()=>{},
    shouldAddRemainingMembers: false,
    setShouldAddRemainingMembers: ()=>{},
    shouldCopyPagePermissions: false,
    setShouldCopyPagePermissions: ()=>{},
    shouldRenderAccessTokenModal: false,
    setShouldRenderAccessTokenModal: ()=>{},
    accessToken: '',
    setAccessToken: ()=>{},
    newSpaceName: '',
    setNewSpaceName: ()=>{},
    setExistingSpace: ()=>{},
    setParentPageId: ()=>{},
    selectedPermissions: (0, $8uc8a.PermissionOptions).DEFAULT,
    setSelectedPermissions: ()=>{}
});
const $c73c161a517b87e3$export$4261666d8e0efef2 = (props)=>{
    const [authProviderError, setAuthProviderError] = (0, $gwFzn.useState)('');
    const [hasSubpages, setHasSubpages] = (0, $gwFzn.useState)(false);
    const dropzoneCancelFnRef = (0, $gwFzn.useRef)(null);
    const browserCancelFnRef = (0, $gwFzn.useRef)(null);
    const [isUploadingFile, setIsUploadingFile] = (0, $gwFzn.useState)(false);
    const [isStartingImport, setIsStartingImport] = (0, $gwFzn.useState)(false);
    const [fileNameDisplay, setFileNameDisplay] = (0, $gwFzn.useState)('');
    const [fileSizeBytes, setFileSizeBytes] = (0, $gwFzn.useState)(0);
    const [filestoreId, setFilestoreId] = (0, $gwFzn.useState)('');
    const [collectionId, setCollectionId] = (0, $gwFzn.useState)('');
    const [shouldMapNotionMembers, setShouldMapNotionMembers] = (0, $gwFzn.useState)(true);
    const [shouldRenderIntegrationTokenModal, setShouldRenderIntegrationTokenModal] = (0, $gwFzn.useState)(false);
    const [shouldRenderCloseDrawerModal, setShouldRenderCloseDrawerModal] = (0, $gwFzn.useState)(false);
    const [integrationToken, setIntegrationToken] = (0, $gwFzn.useState)('');
    const [shouldAddRemainingMembers, setShouldAddRemainingMembers] = (0, $gwFzn.useState)(true);
    const [shouldCopyPagePermissions, setShouldCopyPagePermissions] = (0, $gwFzn.useState)(false);
    const [shouldRenderAccessTokenModal, setShouldRenderAccessTokenModal] = (0, $gwFzn.useState)(false);
    const [accessToken, setAccessToken] = (0, $gwFzn.useState)('');
    const [newSpaceName, setNewSpaceName] = (0, $gwFzn.useState)('');
    const [existingSpace, setExistingSpace] = (0, $gwFzn.useState)();
    const [parentPageId, setParentPageId] = (0, $gwFzn.useState)();
    const [selectedPermissions, setSelectedPermissions] = (0, $gwFzn.useState)((0, $8uc8a.PermissionOptions).DEFAULT);
    (0, $27ffu.useBeforeUnload)('Changes may not be saved', isUploadingFile || isStartingImport);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c73c161a517b87e3$export$7805c3dc7bda328d.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            authProviderError: authProviderError,
            setAuthProviderError: setAuthProviderError,
            hasSubpages: hasSubpages,
            setHasSubpages: setHasSubpages,
            dropzoneCancelFnRef: dropzoneCancelFnRef,
            browserCancelFnRef: browserCancelFnRef,
            isUploadingFile: isUploadingFile,
            setIsUploadingFile: setIsUploadingFile,
            isStartingImport: isStartingImport,
            setIsStartingImport: setIsStartingImport,
            fileNameDisplay: fileNameDisplay,
            setFileNameDisplay: setFileNameDisplay,
            fileSizeBytes: fileSizeBytes,
            setFileSizeBytes: setFileSizeBytes,
            filestoreId: filestoreId,
            setFilestoreId: setFilestoreId,
            collectionId: collectionId,
            setCollectionId: setCollectionId,
            shouldMapNotionMembers: shouldMapNotionMembers,
            setShouldMapNotionMembers: setShouldMapNotionMembers,
            shouldRenderCloseDrawerModal: shouldRenderCloseDrawerModal,
            setShouldRenderCloseDrawerModal: setShouldRenderCloseDrawerModal,
            shouldRenderIntegrationTokenModal: shouldRenderIntegrationTokenModal,
            setShouldRenderIntegrationTokenModal: setShouldRenderIntegrationTokenModal,
            integrationToken: integrationToken,
            setIntegrationToken: setIntegrationToken,
            shouldAddRemainingMembers: shouldAddRemainingMembers,
            setShouldAddRemainingMembers: setShouldAddRemainingMembers,
            shouldCopyPagePermissions: shouldCopyPagePermissions,
            setShouldCopyPagePermissions: setShouldCopyPagePermissions,
            shouldRenderAccessTokenModal: shouldRenderAccessTokenModal,
            setShouldRenderAccessTokenModal: setShouldRenderAccessTokenModal,
            accessToken: accessToken,
            setAccessToken: setAccessToken,
            newSpaceName: newSpaceName,
            setNewSpaceName: setNewSpaceName,
            existingSpace: existingSpace,
            parentPageId: parentPageId,
            setParentPageId: setParentPageId,
            setExistingSpace: setExistingSpace,
            selectedPermissions: selectedPermissions,
            setSelectedPermissions: setSelectedPermissions
        }
    }, props.children);
};
const $c73c161a517b87e3$export$316a7de2e8141cc8 = (0, $iFWZA.createHook)($c73c161a517b87e3$export$390f32400eaf98c9);

});
parcelRegister("8uc8a", function(module, exports) {

$parcel$export(module.exports, "PermissionOptions", () => $9db47457289923c5$export$e64befb57ff51d2d);
var $9db47457289923c5$export$e64befb57ff51d2d = /*#__PURE__*/ function(PermissionOptions) {
    PermissionOptions["RESTRICTED"] = "RESTRICTED";
    PermissionOptions["NOTION"] = "NOTION";
    PermissionOptions["DEFAULT"] = "DEFAULT";
    return PermissionOptions;
}({});

});

parcelRegister("27ffu", function(module, exports) {

$parcel$export(module.exports, "useBeforeUnload", () => $0a41942d2e8255bf$export$c0a586b329cae57d);

var $gwFzn = parcelRequire("gwFzn");
const $0a41942d2e8255bf$export$c0a586b329cae57d = (message, isUploadingFile)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (isUploadingFile) {
            const handleBeforeUnload = (event)=>{
                event.preventDefault(); // Required to trigger the dialog in some browsers
                event.returnValue = message;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return ()=>{
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [
        message,
        isUploadingFile
    ]);
};

});

parcelRegister("dzqet", function(module, exports) {

$parcel$export(module.exports, "ContentType", () => $b9ba7ab256cbc974$export$e2e108cbe2e4f865);
var $b9ba7ab256cbc974$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["NOTION"] = "NOTION";
    ContentType["MIRO"] = "MIRO";
    ContentType["HTML"] = "HTML";
    return ContentType;
}({});

});


parcelRegister("iEXHN", function(module, exports) {

let $d95a46add4aa54cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d95a46add4aa54cc$var$load("7WcBh"),
    $d95a46add4aa54cc$var$load("2Fobu"),
    $d95a46add4aa54cc$var$load("c6MKV"),
    $d95a46add4aa54cc$var$load("aZinD"),
    $d95a46add4aa54cc$var$load("9JWXo")
]).then(()=>parcelRequire('hSRPs'));

});


parcelRegister("f8AFM", function(module, exports) {

$parcel$export(module.exports, "ConditionalImportContentModal", () => $123d8cc31f005f3d$export$cf1f5228a529b27e);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $jmjWc = parcelRequire("jmjWc");

var $5IN3L = parcelRequire("5IN3L");

var $dzqet = parcelRequire("dzqet");

const $123d8cc31f005f3d$var$ImportContentModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CsuHF",
    name: "ImportContentModalLoader",
    loader: async ()=>(await (parcelRequire("gtloM"))).ImportContentModal
});
const $123d8cc31f005f3d$export$cf1f5228a529b27e = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const makeCardClickHandler = (contentType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'importContentCard',
                    source: 'importContentModal',
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
            importContentActions.setShowImportContentModal(false);
            importContentActions.setContentType(contentType);
            importContentActions.setShouldRenderDrawer(true);
            importContentActions.setShowImportContentDrawer(true);
        };
    return importContentState.shouldRenderModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($123d8cc31f005f3d$var$ImportContentModalLoader, {
        shouldRender: importContentState.showImportContentModal,
        onClose: ()=>importContentActions.setShowImportContentModal(false),
        onMiroClick: makeCardClickHandler((0, $dzqet.ContentType).MIRO),
        onNotionClick: makeCardClickHandler((0, $dzqet.ContentType).NOTION),
        onFileImportClick: makeCardClickHandler((0, $dzqet.ContentType).HTML)
    }) : null;
};

});
parcelRegister("gtloM", function(module, exports) {

let $bfdff415591d08ab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bfdff415591d08ab$var$load("hX5aL").then(()=>parcelRequire('c6LMF'));

});


parcelRegister("gKGjM", function(module, exports) {

$parcel$export(module.exports, "ImportContentButton", () => $02de2c54d3c44def$export$b0d230bf69c0838c);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $56M4r = parcelRequire("56M4r");

var $inPa6 = parcelRequire("inPa6");

var $fNJG8 = parcelRequire("fNJG8");

var $6ekXv = parcelRequire("6ekXv");

var $5IN3L = parcelRequire("5IN3L");
const $02de2c54d3c44def$var$i18n = (0, $2nPZH.defineMessages)({
    buttonText: {
        id: "import-content.button.text",
        defaultMessage: "Import from other tools"
    }
});
const $02de2c54d3c44def$export$b0d230bf69c0838c = ({ isNav4Enabled: isNav4Enabled, closePopup: closePopup })=>{
    const [, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'importContentButton'
            }
        }).fire();
        importContentActions.setShouldRenderModal(true);
        importContentActions.setShowImportContentModal(true);
        closePopup?.('import content clicked');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isNav4Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6ekXv.MenuButtonItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNJG8))), {
            label: "",
            color: "currentColor"
        }),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $02de2c54d3c44def$var$i18n.buttonText)), !isNav4Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $02de2c54d3c44def$var$i18n.buttonText)));
};

});
parcelRegister("fNJG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80edd69ce46ac6c$var$_react = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $b80edd69ce46ac6c$var$_baseNew = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b80edd69ce46ac6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80edd69ce46ac6c$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b80edd69ce46ac6c$var$_react.default.createElement($b80edd69ce46ac6c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b80edd69ce46ac6c$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b80edd69ce46ac6c$var$_default = module.exports.default = $b80edd69ce46ac6c$var$CloudArrowUpIcon;

});

parcelRegister("6ekXv", function(module, exports) {

$parcel$export(module.exports, "MenuButtonItem", () => $448ce58df94ae65f$export$35e89d121b5de79a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5ujhR = parcelRequire("5ujhR");

var $jjpBv = parcelRequire("jjpBv");
const $448ce58df94ae65f$export$35e89d121b5de79a = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $jjpBv.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
				 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
				 * so they aren't rendered in the disabled state.
				 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    }));

});



parcelRegister("8jJQh", function(module, exports) {

$parcel$export(module.exports, "ForgeGlobalKeyboardShortcuts", () => $053fc94f5ddb8d12$export$d15e21537dfa6cb0);

var $gwFzn = parcelRequire("gwFzn");

var $dPJCf = parcelRequire("dPJCf");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $1NBp8 = parcelRequire("1NBp8");

var $7Ndnw = parcelRequire("7Ndnw");

var $dizL5 = parcelRequire("dizL5");

var $8a9Dm = parcelRequire("8a9Dm");

var $4vC63 = parcelRequire("4vC63");
const $053fc94f5ddb8d12$export$d15e21537dfa6cb0 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: module.id,
                    module: module,
                    action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                            appId: (0, $8a9Dm.getAppId)(module),
                            envId: module.environmentId,
                            forgeManifestRoute: module.properties.route
                        }))
                }));
        }
    });
});

});
parcelRegister("dizL5", function(module, exports) {

$parcel$export(module.exports, "lazyForgeUIExtensionsWithLoader", () => $55b20ed34f146485$export$350b371bfb7f5e95);
$parcel$export(module.exports, "LazyForgeUIExtensions", () => $55b20ed34f146485$export$4cbc6d03d50a8849);

var $jmjWc = parcelRequire("jmjWc");

const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("5cTwy"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);

});
parcelRegister("5cTwy", function(module, exports) {

let $3ca924add5fd78e3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ca924add5fd78e3$var$load("lnKog").then(()=>parcelRequire('2mcHd'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("4vC63", function(module, exports) {

$parcel$export(module.exports, "ForgeKeyboardShortcutVisualizer", () => $c1fece3650e281b8$export$b804abdac3f5f117);
$parcel$export(module.exports, "ForgeKeyboardShortcut", () => $c1fece3650e281b8$export$4e51bfd8ba3e71ef);

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $ljm2R = parcelRequire("ljm2R");
const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $ljm2R.ShortcutType).Forge
    }));
    return null;
};

});


parcelRegister("dF1Nh", function(module, exports) {

$parcel$export(module.exports, "StorageEnforcement", () => $7ac3d7089b8f08ca$export$5bf713f6291006b2);

var $gwFzn = parcelRequire("gwFzn");

var $lQKRY = parcelRequire("lQKRY");

var $gXHya = parcelRequire("gXHya");

var $7fePz = parcelRequire("7fePz");
const $7ac3d7089b8f08ca$export$5bf713f6291006b2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lQKRY.StorageEnforcementFlags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gXHya.GracePeriodModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7fePz.BlockCreateModal), null));
};

});
parcelRegister("lQKRY", function(module, exports) {

$parcel$export(module.exports, "StorageEnforcementFlags", () => $3729a951937314e9$export$8df08a490eb32a33);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $3729a951937314e9$var$StorageEnforcementFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_U9ss",
    name: "StorageEnforcementFlagsLoadable",
    loader: async ()=>(await (parcelRequire("7T9I0"))).StorageEnforcementFlags
});
const $3729a951937314e9$export$8df08a490eb32a33 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3729a951937314e9$var$StorageEnforcementFlagsLoadable, null) : null;
};

});
parcelRegister("alLTz", function(module, exports) {

$parcel$export(module.exports, "useIsStorageEnforcementEligible", () => $2f3a7af74886cca0$export$3fc4fcb674af9bce);

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};

});

parcelRegister("7T9I0", function(module, exports) {

let $5be5336bde2dcf50$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5be5336bde2dcf50$var$load("dIKKx").then(()=>parcelRequire('eYRFW'));

});


parcelRegister("gXHya", function(module, exports) {

$parcel$export(module.exports, "GracePeriodModal", () => $372cb008daefafdd$export$38134b9c38b2723c);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $372cb008daefafdd$var$GracePeriodModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6zo21",
    name: "GracePeriodModalLoadable",
    loader: async ()=>(await (parcelRequire("dXCEe"))).GracePeriodModalErrorBoundary
});
const $372cb008daefafdd$export$38134b9c38b2723c = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($372cb008daefafdd$var$GracePeriodModalLoadable, null) : null;
};

});
parcelRegister("dXCEe", function(module, exports) {

let $a29ec3baae68c2ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a29ec3baae68c2ec$var$load("52dqm").then(()=>parcelRequire('3zSMJ'));

});


parcelRegister("7fePz", function(module, exports) {

$parcel$export(module.exports, "BlockCreateModal", () => $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $2c6a471f2dd5d9be$var$BlockCreateModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mxabm",
    name: "BlockCreateModalLoadable",
    loader: async ()=>(await (parcelRequire("1imqr"))).BlockCreateModal
});
const $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2c6a471f2dd5d9be$var$BlockCreateModalLoadable, null) : null;
};

});
parcelRegister("1imqr", function(module, exports) {

let $0f18de22beb105c2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0f18de22beb105c2$var$load("gIOIL").then(()=>parcelRequire('gLUng'));

});



parcelRegister("24JrB", function(module, exports) {

$parcel$export(module.exports, "OnboardingQuickstart", () => $504edb24d929a4b3$export$803d8a70000e4583);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $52id1 = parcelRequire("52id1");

const $504edb24d929a4b3$var$OnboardingQuickstartLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "A7UDO",
    name: "OnboardingQuickstartLoadable",
    loader: async ()=>{
        const { OnboardingQuickstartComponent: OnboardingQuickstartComponent } = await (parcelRequire("12YAW"));
        return OnboardingQuickstartComponent;
    }
});
const $504edb24d929a4b3$export$803d8a70000e4583 = ({ children: children })=>{
    const { isQuickstartEligible: isQuickstartEligible } = (0, $52id1.useQuickstartEligible)();
    return isQuickstartEligible() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($504edb24d929a4b3$var$OnboardingQuickstartLoadable, null, children) : null;
};

});
parcelRegister("12YAW", function(module, exports) {

let $0c34fb397671c6db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0c34fb397671c6db$var$load("ir7Dc"),
    $0c34fb397671c6db$var$load("6dDCB"),
    $0c34fb397671c6db$var$load("5rLJa"),
    $0c34fb397671c6db$var$load("e53Dv"),
    $0c34fb397671c6db$var$load("4FLkP"),
    $0c34fb397671c6db$var$load("9ldIR"),
    $0c34fb397671c6db$var$load("c6MKV"),
    $0c34fb397671c6db$var$load("aiceI"),
    $0c34fb397671c6db$var$load("iiqDR"),
    $0c34fb397671c6db$var$load("dUKeO"),
    $0c34fb397671c6db$var$load("3ooAX"),
    $0c34fb397671c6db$var$load("hzK1f"),
    $0c34fb397671c6db$var$load("fqrMn"),
    $0c34fb397671c6db$var$load("fYi1a"),
    $0c34fb397671c6db$var$load("bjzRn"),
    $0c34fb397671c6db$var$load("8mzoy"),
    $0c34fb397671c6db$var$load("7a9CL"),
    $0c34fb397671c6db$var$load("ivQYH"),
    $0c34fb397671c6db$var$load("8pE8S"),
    $0c34fb397671c6db$var$load("9Bu2S"),
    $0c34fb397671c6db$var$load("42vdC"),
    $0c34fb397671c6db$var$load("P5iE2"),
    $0c34fb397671c6db$var$load("aZinD"),
    $0c34fb397671c6db$var$load("6StWh"),
    $0c34fb397671c6db$var$load("aHbYg"),
    $0c34fb397671c6db$var$load("4aLlP"),
    $0c34fb397671c6db$var$load("dNm46")
]).then(()=>parcelRequire('3losQ'));

});


parcelRegister("7LK1f", function(module, exports) {

$parcel$export(module.exports, "RovoVideoModal", () => $4ff48be53273ace9$export$31575bcfa345fe24);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

const $4ff48be53273ace9$var$RovoVideoModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "bb89X",
    name: "RovoVideoModalLoadable",
    loader: async ()=>(await (parcelRequire("gk9YD"))).RovoVideoModal
});
const $4ff48be53273ace9$export$31575bcfa345fe24 = ()=>{
    return (0, $9wGTI.fg)('confluence_rovo_video_player_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH_LUNA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4ff48be53273ace9$var$RovoVideoModalLoadable, null)) : null;
};

});
parcelRegister("gk9YD", function(module, exports) {

let $be2640d0db6e62d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $be2640d0db6e62d6$var$load("aiceI"),
    $be2640d0db6e62d6$var$load("9QvHa"),
    $be2640d0db6e62d6$var$load("3CJXT")
]).then(()=>parcelRequire('hGU26'));

});


parcelRegister("61vzn", function(module, exports) {

$parcel$export(module.exports, "TrialFlags", () => $5e8e088fe72e4df1$export$c108f21945b8b79);
$parcel$export(module.exports, "PremiumLozengeLoadable", () => $5e8e088fe72e4df1$export$62673719cbe80cd0);
$parcel$export(module.exports, "ReverseTrialLozengeExperiment", () => $5e8e088fe72e4df1$export$b51195909514673e);
$parcel$export(module.exports, "PremiumLozengeImage", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("leRtl")))));

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $leRtl = parcelRequire("leRtl");


const $5e8e088fe72e4df1$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pBDfE",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("hfSv4"))).TrialFlags
});
const $5e8e088fe72e4df1$export$c108f21945b8b79 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5e8e088fe72e4df1$var$TrialFlagsLoadable, null));

const $5e8e088fe72e4df1$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Txnkb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("lhVPO"))).PremiumLozenge
});

const $5e8e088fe72e4df1$export$212b4f568257f60f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "E5jvU",
    name: "LazyAutoUpgradeAwarenessModal",
    loader: async ()=>(await (parcelRequire("4R0Br"))).AutoUpgradeAwarenessModal
});

const $5e8e088fe72e4df1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EHgbD",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("eeA8N"))).ReverseTrialLozenge
});

const $5e8e088fe72e4df1$export$e82a504f7cb45e99 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DLH6o",
    name: "ReverseTrialLozengeListItemExperiment",
    loader: async ()=>(await (parcelRequire("fz8y2"))).ReverseTrialListItem
});

});
parcelRegister("leRtl", function(module, exports) {
module.exports = new URL("premiumLozenge.aa9b0435.svg", import.meta.url).toString();

});

parcelRegister("hfSv4", function(module, exports) {

let $c8fe1cfbeff454a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c8fe1cfbeff454a9$var$load("cmcKh"),
    $c8fe1cfbeff454a9$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("lhVPO", function(module, exports) {

let $f7f80c459b873240$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7f80c459b873240$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("4R0Br", function(module, exports) {

let $388c94659c0645ac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $388c94659c0645ac$var$load("4fCJZ"),
    $388c94659c0645ac$var$load("dTsOE"),
    $388c94659c0645ac$var$load("x8U2P")
]).then(()=>parcelRequire('6yR7w'));

});

parcelRegister("eeA8N", function(module, exports) {

let $a5ce6850d4a06c24$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5ce6850d4a06c24$var$load("fqBFU").then(()=>parcelRequire('gQsLh'));

});

parcelRegister("fz8y2", function(module, exports) {

let $b550c1568712cf74$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b550c1568712cf74$var$load("1HAEl").then(()=>parcelRequire('f3FIN'));

});


parcelRegister("i5Ioa", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $2a2fcb666bddc8b3$export$c17561cb55d4db30);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $9wGTI = parcelRequire("9wGTI");

var $kmyZQ = parcelRequire("kmyZQ");

var $2TpIg = parcelRequire("2TpIg");
const $2a2fcb666bddc8b3$export$c17561cb55d4db30 = /*#__PURE__*/ (0, $gwFzn.memo)(({ theme: theme, isNav4: isNav4 })=>{
    if ((0, $9wGTI.fg)('confluence_hide_loading_bar_all_types')) return null;
    const highlightColor = theme && theme.mode.productHome.backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2TpIg.WrappedProgressBar), {
            highlightColor: highlightColor,
            status: progressBar.getStatus(),
            progressBar: progressBar,
            duration: progressBar.getDuration(),
            isNav4: isNav4
        }));
});

});
parcelRegister("kmyZQ", function(module, exports) {

$parcel$export(module.exports, "ProgressBarContainer", () => $766713eeaff568b4$export$91fd6e064cf0bcf3);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");


var $9wGTI = parcelRequire("9wGTI");

var $1ps47 = parcelRequire("1ps47");
class $766713eeaff568b4$export$91fd6e064cf0bcf3 extends (0, $ipPpS.Container) {
    getInitialStatus(state) {
        if (state) return state.status;
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = (0, window.__SSR_RENDERED__);
        if (isSSR && (0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) {
            // window.__SSR_IS_LIVE_PAGE__ only works in hydration after SSR, so need to use ssr-inputs when its in SSR mode to get the live page data.
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            const isLivePageSSR = (0, window.__SSR_IS_LIVE_PAGE__);
            if (isLivePageSSR) return 'RESET';
        }
        return isSSR ? 'SSR' : 'RESET';
    }
    constructor(state){
        super();
        this.exitAnimationTimer = void 0;
        this.delayedAnimationTimer = void 0;
        this.timeoutTimer = void 0;
        /**
     * There are race conditions where we try to start too soon after resetting,
     * with the result being that state is not yet updated and the start fails.
     * This class property is a hack used to circumvent that behavior.
     */ this.recentlyReset = false;
        /**
     * isStarting is used for handling a race condition.
     * When a page is cached, start() and finish() are fired simultaneously.
     * In start() function, setState({ status: "START" }) is async,
     * so when finish() is invoked, status haven't been set to "START" yet.
     */ this.isStarting = false;
        this.isStopping = false;
        this.prevMatch = null;
        this.isRunning = ()=>(this.state.status === 'START' || this.isStarting) && !this.isStopping;
        this.isDelayed = ()=>this.state.status === 'DELAYED';
        this.hasStarted = ()=>this.isRunning() || this.isDelayed();
        this.isStartable = ()=>this.state.status === 'RESET' || this.state.status === 'SSR' || this.recentlyReset;
        this.getStatus = ()=>{
            return this.state.status;
        };
        this.getDuration = ()=>{
            return this.state.duration || (0, $1ps47.DEFAULT_LOADING_DURATION);
        };
        /**
     * The progress bar start to move.
     */ this.start = (duration = (0, $1ps47.DEFAULT_LOADING_DURATION), timeoutDuration = (0, $1ps47.TIMEOUT_TIMER))=>{
            if (!this.isStartable()) return Promise.resolve();
            this.recentlyReset = false;
            this.isStarting = true;
            /**
       * If the progress bar has started, and haven't received a finish signal within ${DEFAULT_LOADING_DURATION}ms,
       * render shimmer and linear-gradient effect.
       */ this.delayedAnimationTimer = setTimeout(()=>{
                if (!this.isRunning()) return;
                this.setState({
                    status: 'DELAYED'
                });
            }, duration);
            /**
       * If the progress bar has started, and haven't received a finish signal within ${TIMEOUT_TIMER}ms,
       * hide the progress bar, and reset the data.
       */ this.timeoutTimer = setTimeout(()=>{
                if (!this.isDelayed()) return;
                this.reset();
            }, timeoutDuration);
            return this.setState({
                status: 'START',
                duration: duration
            }, ()=>{
                this.isStarting = false;
            });
        };
        /**
     * Trigger the progress bar to move to the end quickly.
     */ this.finish = ()=>{
            if (!(this.isRunning() || this.isDelayed())) return;
            this.isStopping = true;
            let promise;
            if (this.isDelayed()) promise = this.reset();
            else {
                if ((0, $9wGTI.fg)('confluence_progress-bar-bugfix')) this.isStarting = false;
                promise = this.setState({
                    status: 'FINISH'
                }, ()=>{
                    this.isStopping = false;
                });
            }
            this.exitAnimationTimer = setTimeout(()=>{
                this.reset();
            }, (0, $1ps47.POST_FINISHED_IDLE_DURATION));
            return promise;
        };
        /**
     * Hide the progress bar and reset the data.
     */ this.reset = ()=>{
            clearTimeout(this.exitAnimationTimer);
            clearTimeout(this.delayedAnimationTimer);
            clearTimeout(this.timeoutTimer);
            const promise = this.setState({
                status: 'RESET'
            });
            this.recentlyReset = true;
            this.isStopping = false;
            return promise;
        };
        this.state = {
            status: this.getInitialStatus(state),
            duration: state && state.duration || (0, $1ps47.DEFAULT_LOADING_DURATION)
        };
    }
}

});
parcelRegister("1ps47", function(module, exports) {

$parcel$export(module.exports, "PROGRESS_STYLE_ID", () => $91d046db84f1ff20$export$472f7f1dd63f0a09);
$parcel$export(module.exports, "PROGRESS_BAR_ID", () => $91d046db84f1ff20$export$3acd3aa8281b07d8);
$parcel$export(module.exports, "DEFAULT_LOADING_BAR_COLOR", () => $91d046db84f1ff20$export$53d51cc6d57e44da);
$parcel$export(module.exports, "EXIT_ANIMATION_SPEED", () => $91d046db84f1ff20$export$5412169de0facc6c);
$parcel$export(module.exports, "DEFAULT_LOADING_DURATION", () => $91d046db84f1ff20$export$899393f3e23f724b);
$parcel$export(module.exports, "TIMEOUT_TIMER", () => $91d046db84f1ff20$export$7868b416d8929c55);
$parcel$export(module.exports, "POST_FINISHED_IDLE_DURATION", () => $91d046db84f1ff20$export$55cff6338bbd9ca8);
const $91d046db84f1ff20$export$472f7f1dd63f0a09 = 'progressStyles';
const $91d046db84f1ff20$export$3acd3aa8281b07d8 = 'global-progress-bar';
const $91d046db84f1ff20$export$53d51cc6d57e44da = "var(--ds-background-brand-bold, #0C66E4)";
const $91d046db84f1ff20$export$5412169de0facc6c = 300;
const $91d046db84f1ff20$export$899393f3e23f724b = 6000;
const $91d046db84f1ff20$export$7868b416d8929c55 = 20000;
const $91d046db84f1ff20$export$55cff6338bbd9ca8 = $91d046db84f1ff20$export$5412169de0facc6c + 50;

});


parcelRegister("2TpIg", function(module, exports) {

$parcel$export(module.exports, "WrappedProgressBar", () => $c75afe39495ae8f4$export$fa6e04c8cb414d0e);
/* WrappedProgressBar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint react/no-danger: 0 */ /* eslint @atlaskit/ui-styling-standard/no-global-styles: 0 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $1ps47 = parcelRequire("1ps47");

var $ec2MS = parcelRequire("ec2MS");

var $76b2E = parcelRequire("76b2E");
const $c75afe39495ae8f4$var$newStyledProgressBarStyles = null;
const $c75afe39495ae8f4$var$ssrAnimation = null;
const $c75afe39495ae8f4$var$shimmerAnimation = null;
const $c75afe39495ae8f4$var$animationRules = {
    ssrOnly: "_y44va4o2",
    ssrAndDelayed: "_y44vvw8g",
    delayed: "_y44v16yq"
};
const $c75afe39495ae8f4$var$getStyledAttributes = (status, duration, ssrProgressBarDuration, ssrProgressBarLoadPercent)=>{
    switch(status){
        case 'START':
            return {
                transform: 'scaleX(0.99)',
                transitionDuration: `${duration}ms`
            };
        case 'FINISH':
            return {
                transform: 'scaleX(1)',
                transitionDuration: `${0, $1ps47.EXIT_ANIMATION_SPEED}ms`
            };
        case 'DELAYED':
            return {
                animation: 'shimmer 1200ms infinite',
                isDelayed: true,
                transform: 'scaleX(1)',
                transitionDuration: '0ms'
            };
        case 'SSR':
            // When browser is rendering the static HTML progress from 0 to 1/3
            // Then when SPA loads proceed from 33.33% to 99%, then 100% when apdex ends
            return {
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                animation: 'none',
                transform: `scaleX(${ssrProgressBarLoadPercent / 100})`,
                transitionDuration: '0ms'
            };
        case 'RESET':
        default:
            return {
                animation: 'none',
                transform: `scaleX(0)`,
                transitionDuration: '0ms'
            };
    }
};
const $c75afe39495ae8f4$var$StyledProgressBar = ({ isDelayed: isDelayed, background: background, style: style })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            background: background,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style
        },
        "data-vc": "global-progress-bar-nav3",
        "data-testid": (0, $1ps47.PROGRESS_BAR_ID),
        className: (0, $35pXk.default)([
            "_4t3iyh40 _tzy41ck0 _kqswstnw _8hrz1nty _1bsb1osq _m6k41e03 _1pby18h8",
            isDelayed && true && $c75afe39495ae8f4$var$animationRules['delayed'],
            !isDelayed && undefined,
            isDelayed && undefined
        ])
    });
}; //start Nav 4 styles
const $c75afe39495ae8f4$var$generateLoadingBarStyles = ({ animation: animation = 'none', background: background, isDelayed: isDelayed, transform: transform, isNav4: isNav4, transitionDuration: transitionDuration })=>{
    return `
	body::before{
    content: '';
    display: block;
    animation: ${animation};
	  background: ${// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background};
    height: 2px;
    z-index: 999;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
	transform: ${transform};
	transition-duration: ${transitionDuration};
    transform-origin: 0 0;
    will-change: transform;
  }
  ${''}
	${isDelayed ? ` @keyframes shimmer { from { left: -15%; width: 15%; } to { left: 115%; width: 15%; } }` : ''}
	${isNav4 ? `opacity: '0.6',
	position: 'absolute',
	transformOrigin: '0 0',
	width: '100%',
	willChange: 'transform'` : ''}
	${// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    isNav4 && isDelayed && true ? `@keyframes shimmer {
			from: { left: '-15%', width: '15%' },
			to: { left: '115%', width: '15%' }
		}` : ''}
	${''}
	${''}
`;
};
const $c75afe39495ae8f4$export$fa6e04c8cb414d0e = ({ highlightColor: highlightColor = (0, $1ps47.DEFAULT_LOADING_BAR_COLOR), status: status, duration: duration, progressBar: progressBar, isNav4: isNav4 })=>{
    const ssrAttributes = $c75afe39495ae8f4$var$getStyledAttributes('SSR', 0, 6000, // ssrProgressBarDuration
    80 // ssrProgressBarLoadPercent
    ); // Initially, set progress bar to 0%, this ensures that progress bar does not start with 99% on the first load
    const initialAttributes = $c75afe39495ae8f4$var$getStyledAttributes('RESET', duration, 6000, // ssrProgressBarDuration,
    80 // ssrProgressBarLoadPercent
    );
    const [attributes, setAttributes] = (0, $gwFzn.useState)(// If the page is currently rendering on the server-side or was rendered on server-side
    // We need to set the start point synchronously
    status === 'SSR' ? ssrAttributes : initialAttributes);
    (0, $ec2MS.useProgressBarController)(progressBar);
    (0, $76b2E.useProgressBarListenerController)(progressBar); /**
                                                  * this logic (useEffect -> setTimeout -> setState) is necessary to fix a
                                                  * rendering issue where the progress bar animation starts loading at 99%.
                                                  * this should be investigated more and solved in a future ticket.
                                                  */ 
    (0, $gwFzn.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setAttributes($c75afe39495ae8f4$var$getStyledAttributes(status, duration, 6000, // ssrProgressBarDuration,
            80 // ssrProgressBarLoadPercent
            ));
        }, 0);
        return ()=>clearTimeout(timeout);
    }, [
        duration,
        status
    ]);
    const dynamicLoadingStyles = $c75afe39495ae8f4$var$generateLoadingBarStyles({
        ...attributes,
        background: highlightColor
    });
    if ((0, $9wGTI.fg)('confluence_frontend_dynamic_nav3_progress_bar')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
        "data-testid": (0, $1ps47.PROGRESS_BAR_ID),
        dangerouslySetInnerHTML: {
            __html: dynamicLoadingStyles
        },
        "data-vc": attributes.isNav4 ? '' : 'global-progress-bar-nav3'
    });
    return isNav4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
        "data-testId": (0, $1ps47.PROGRESS_STYLE_ID),
        dangerouslySetInnerHTML: {
            __html: dynamicLoadingStyles
        }
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c75afe39495ae8f4$var$StyledProgressBar, {
        isNav4: false,
        background: highlightColor,
        style: attributes
    });
};

});
parcelRegister("ec2MS", function(module, exports) {

$parcel$export(module.exports, "useProgressBarController", () => $953a05b2dab9a5d3$export$724ea2b284503598);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");

var $lSOAM = parcelRequire("lSOAM");

var $9wGTI = parcelRequire("9wGTI");

var $9sGCn = parcelRequire("9sGCn");

var $98zed = parcelRequire("98zed");
/**
 * "contentSlug" is changable due to url encode, content title contains special charactor, changed title, etc.
 * If "contentSlug" changed, URL will be redirected, but the page content won't rerender.
 * In this case, the progress bar should not show up.
 * To handle that, use "contentId" as screen's identity, instead of pathname.
 * Assuming if a URL contains "contentSlug" param, then it much contains "contentId" as well.
 * The above assumption is valid according to: next/packages/named-routes/src/index.ts
 *
 * Another circumstance that progress bar should not show up is, when blog post url changed from pattern VIEW_BLOG_DATE_LEGACY to VIEW_BLOG or conversely.
 */ function $953a05b2dab9a5d3$var$isPreviousPage(match, prevMatch) {
    if (match && match.params && match.name && prevMatch && prevMatch.params && prevMatch.name && (match.name === prevMatch.name || match.name.startsWith('VIEW_BLOG') && prevMatch.name.startsWith('VIEW_BLOG') && 'contentSlug' in match.params && 'contentSlug' in prevMatch.params || match.name === 'HOME' && prevMatch.name === 'WIKI')) return prevMatch.params.contentId === match.params.contentId;
    return false;
}
const $953a05b2dab9a5d3$export$724ea2b284503598 = (progressBar)=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    (0, $gwFzn.useEffect)(()=>{
        const shouldHideProgressBar = ()=>{
            const conditions = [
                ()=>{
                    // Hide the progress bar for all live pages.
                    if (!(0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) return false;
                    // Check for SSR'd live page. If it is, hide the progress bar.
                    if (livePageSSRStatus?.isTypeKnown && livePageSSRStatus?.isLive) return true;
                    // Check for non-SSR'd live data from live pages fast loading. If it is, hide the progress bar.
                    const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(match?.params.contentId);
                    const isLivePage = subType === 'live' && isArchived === false;
                    return isLivePage && match?.name === 'VIEW_PAGE';
                }
            ];
            return conditions.some((condition)=>condition());
        };
        if (!$953a05b2dab9a5d3$var$isPreviousPage(match, progressBar.prevMatch)) {
            // These are special conditions where we hide the progress bar for perceived performance experiments.
            if (shouldHideProgressBar()) progressBar.reset();
            else if ((0, $lSOAM.isBMPageLoad)(match) && (0, $lSOAM.hasBMPageLoadStarted)()) progressBar.start();
            else progressBar.reset();
        }
        progressBar.prevMatch = match;
        return ()=>{
            progressBar.reset();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        match && match.pathname
    ]);
};

});
parcelRegister("98zed", function(module, exports) {

$parcel$export(module.exports, "useIsLivePageWithSSR", () => $91141199ce9a5735$export$899773b8bcad4fc7);

var $dPJCf = parcelRequire("dPJCf");

var $eNbbn = parcelRequire("eNbbn");
const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};

});


parcelRegister("76b2E", function(module, exports) {

$parcel$export(module.exports, "useProgressBarListenerController", () => $fb45058d7703419b$export$70df3474f6d5549);

var $gwFzn = parcelRequire("gwFzn");

var $ew3Dj = parcelRequire("ew3Dj");
const $fb45058d7703419b$export$70df3474f6d5549 = (progressBar)=>{
    const { start: start, finish: finish } = progressBar;
    const postMessageHandler = (0, $gwFzn.useCallback)((event)=>{
        if (event.data && event.data.eventType == (0, $ew3Dj.START_MESSAGE_TYPE)) start(event.data.startDuration, event.data.delayDuration);
        if (event.data && event.data.eventType == (0, $ew3Dj.FINISH_MESSAGE_TYPE)) finish();
    }, [
        start,
        finish
    ]);
    (0, $gwFzn.useEffect)(()=>{
        window.addEventListener('message', postMessageHandler);
        return ()=>{
            window.removeEventListener('message', postMessageHandler);
        };
    }, [
        postMessageHandler
    ]);
};

});
parcelRegister("ew3Dj", function(module, exports) {

$parcel$export(module.exports, "START_MESSAGE_TYPE", () => $d8f8f2e6d4b52281$export$2613057e8390a95c);
$parcel$export(module.exports, "FINISH_MESSAGE_TYPE", () => $d8f8f2e6d4b52281$export$87f9c116a4a9abb1);
const $d8f8f2e6d4b52281$export$2613057e8390a95c = 'start_progress_bar';
const $d8f8f2e6d4b52281$export$87f9c116a4a9abb1 = 'finish_progress_bar';

});




parcelRegister("cOQgu", function(module, exports) {

$parcel$export(module.exports, "useAddUFOCustomDataForNavType", () => $560a905f50f30e05$export$209ba536680f5b50);

var $gwFzn = parcelRequire("gwFzn");

var $cbc8g = parcelRequire("cbc8g");

var $gz8ZY = parcelRequire("gz8ZY");
const $560a905f50f30e05$export$209ba536680f5b50 = ()=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    // Adds the "custom:confluence:navType" property to UFO page load event to enable
    // Nav3/Nav4 split in the performance portal. Must be called on each route as it
    // only adds custom data to the existing interaction
    (0, $gwFzn.useEffect)(()=>{
        (0, $cbc8g.addUFOCustomData)({
            'confluence:navType': isNav4Enabled ? 'nav4' : 'nav3'
        });
    });
};

});
parcelRegister("cbc8g", function(module, exports) {

$parcel$export(module.exports, "addUFOCustomData", () => $0483100954c0c407$export$d12f56a472cdbe6c);

var $gwFzn = parcelRequire("gwFzn");

var $9x4nt = parcelRequire("9x4nt");

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");
function $0483100954c0c407$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    (0, $gwFzn.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $0483100954c0c407$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $4u5NT.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $4u5NT.addCustomData)(currentInteractionId, [], data);
}

});


parcelRegister("2tne1", function(module, exports) {

$parcel$export(module.exports, "Nav4FeedbackCollectorModal", () => $d1cfd6c372349151$export$2b5e717cd94c6edd);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $biiXa = parcelRequire("biiXa");
var $29DUH = parcelRequire("29DUH");

var $6uGcC = parcelRequire("6uGcC");

var $2Nwuj = parcelRequire("2Nwuj");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $deyhs = parcelRequire("deyhs");
var $gz8ZY = parcelRequire("gz8ZY");
var $9hcBu = parcelRequire("9hcBu");
var $hthDv = parcelRequire("hthDv");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $b27jz = parcelRequire("b27jz");
const $d1cfd6c372349151$var$NAV_4_FEEDBACK_ENTRYPOINT_ID = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $d1cfd6c372349151$var$NAV_4_FEEDBACK_GROUP_ID = 'confluence-nav-4-sidebar';
const $d1cfd6c372349151$var$DEFAULT_CONTEXT = [
    {
        id: 'feedback-group-id',
        value: $d1cfd6c372349151$var$NAV_4_FEEDBACK_GROUP_ID
    }
];
const $d1cfd6c372349151$var$i18n = (0, $2nPZH.defineMessages)({
    feedbackCollectorTitle: {
        id: "nav4-feedback.feedback-collector.title",
        defaultMessage: "Help us improve the new navigation"
    },
    feedbackCollectorTitleDetails: {
        id: "nav4-feedback.feedback-collector.title-details",
        defaultMessage: "We\u2019d love to hear about your experience with the new navigation."
    },
    feedbackCollectorTitleDetailsOptOut: {
        id: "nav4-feedback.feedback-collector.title-details.opt-out",
        defaultMessage: "We\u2019d love to hear about your experience with the new navigation. If needed, you can <a>switch back to the old navigation</a>."
    },
    feedbackCollectorOptOutTitle: {
        id: "nav4-feedback.feedback-collector.opt-out.title",
        defaultMessage: "Switch back to the old navigation"
    },
    feedbackCollectorOptOutTitleDetails: {
        id: "nav4-feedback.feedback-collector.opt-out.title-details",
        defaultMessage: "We\u2019re sad to see you go. To help us improve the navigation for all users, please share why the new navigation didn\u2019t work well for you."
    },
    customTextAreaLabel: {
        id: "nav4-feedback.feedback-collector.custom-text-area-label",
        defaultMessage: "Let us know why you want to switch back"
    },
    submitButtonLabel: {
        id: "nav4-feedback.feedback-collector.submit-button-label",
        defaultMessage: "Switch back"
    }
});
const $d1cfd6c372349151$var$BASIC_NAV4_FEEDBACK_COLLECTOR_TEXT = {
    title: $d1cfd6c372349151$var$i18n.feedbackCollectorTitle,
    description: $d1cfd6c372349151$var$i18n.feedbackCollectorTitleDetails,
    textArea: undefined,
    buttonText: undefined
};
const $d1cfd6c372349151$var$OPT_OUT_NAV4_FEEDBACK_COLLECTOR_TEXT = {
    title: $d1cfd6c372349151$var$i18n.feedbackCollectorOptOutTitle,
    description: $d1cfd6c372349151$var$i18n.feedbackCollectorOptOutTitleDetails,
    textArea: $d1cfd6c372349151$var$i18n.customTextAreaLabel,
    buttonText: $d1cfd6c372349151$var$i18n.submitButtonLabel
};
const $d1cfd6c372349151$var$getTextRecord = (optingOut)=>{
    if (optingOut && (0, $9wGTI.fg)('confluence_nav_4')) return $d1cfd6c372349151$var$OPT_OUT_NAV4_FEEDBACK_COLLECTOR_TEXT;
    return $d1cfd6c372349151$var$BASIC_NAV4_FEEDBACK_COLLECTOR_TEXT;
};
const $d1cfd6c372349151$export$2b5e717cd94c6edd = ()=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, displayName: displayName, locale: locale } = (0, $bQm3c.useSessionData)();
    const [{ isOpen: isOpen, optingOut: optingOut }, { close: close, openOptOutModal: openOptOutModal }] = (0, $b27jz.useNav4FeedbackCollectorStore)();
    const [shouldDisplayFlag, setShouldDisplayFlag] = (0, $gwFzn.useState)(false);
    // The reminder banner should be displayed before users are a few days away from being forced into nav 4.
    // The only distinction between the two banners is the text.
    const storageKey = (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner') ? (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NAV4_PROMPT_REMINDER_BANNER_FIRST_DISMISSED : (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NAV4_PROMPT_BANNER_FIRST_DISMISSED;
    const onSiteWideNav4UpdateCompleted = ()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem(storageKey, null);
    };
    const { updateNav4OptOut: updateAdminNav4, isAdminUpdateSuccessful: isAdminUpdateSuccessful } = (0, $9hcBu.useNav4OptOut)();
    const { updateNav4OptIn: updateSiteWideNav4, isSiteWideUpdateSuccessful: isSiteWideUpdateSuccessful } = (0, $hthDv.useUpdateNav4OptIn)({
        newIsNav4OptedIn: false,
        onCompleted: onSiteWideNav4UpdateCompleted
    });
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    const textRecord = $d1cfd6c372349151$var$getTextRecord(optingOut);
    (0, $gwFzn.useEffect)(()=>{
        close();
        if (isSiteWideUpdateSuccessful && isAdminUpdateSuccessful) window.location.reload();
    }, [
        close,
        isAdminUpdateSuccessful,
        isSiteWideUpdateSuccessful,
        storageKey
    ]);
    const onSubmit = ()=>{
        /**
     * There are two scenarios where a user can opt out
     * EAP users: on the profile menu (personal opt out)
     * Phase 1 users: in the new features page (site-wide and personal opt out)
     */ if (optingOut) {
            const AUDIENCE = (0, $9wGTI.fg)('confluence_nav_4') ? 'EAP' : currentGAPhase === 1 ? 'GA' : null;
            updateAdminNav4(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'switchBackOldNavigation',
                    source: 'nav4FeedbackCollector',
                    attributes: {
                        isTenantUpdated: !(0, $9wGTI.fg)('confluence_nav_4'),
                        isUserUpdated: isNav4DisplayedToUser,
                        audience: AUDIENCE
                    }
                }
            }).fire();
            updateSiteWideNav4({
                variables: {
                    isNav4OptedIn: false
                }
            });
        } else {
            setShouldDisplayFlag(true);
            close();
        }
    };
    const context = optingOut ? [
        ...$d1cfd6c372349151$var$DEFAULT_CONTEXT,
        {
            id: 'opt-out',
            value: 'true'
        }
    ] : $d1cfd6c372349151$var$DEFAULT_CONTEXT;
    const getFeedbackTitleDetails = ()=>{
        //only show optItem when BETA/EAP FF is on.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if (!optingOut && (0, $9wGTI.fg)('confluence_nav_4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, intl.formatMessage($d1cfd6c372349151$var$i18n.feedbackCollectorTitleDetailsOptOut, {
            a: (chunks)=>// eslint-disable-next-line jsx-a11y/anchor-is-valid
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: "#",
                    onClick: openOptOutModal
                }, chunks)
        }));
        return textRecord.description && intl.formatMessage(textRecord.description);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $biiXa.default), {
        locale: locale,
        name: displayName ?? undefined,
        atlassianAccountId: userId ?? undefined,
        entrypointId: $d1cfd6c372349151$var$NAV_4_FEEDBACK_ENTRYPOINT_ID,
        onClose: close,
        onSubmit: onSubmit,
        showTypeField: true,
        feedbackTitle: textRecord.title && intl.formatMessage(textRecord.title),
        feedbackTitleDetails: getFeedbackTitleDetails(),
        customTextAreaLabel: textRecord.textArea && intl.formatMessage(textRecord.textArea),
        submitButtonLabel: textRecord.buttonText && intl.formatMessage(textRecord.buttonText),
        additionalFields: [
            {
                id: 'customfield_10047',
                value: context.map(({ id: id, value: value })=>`${id}: ${String(value)}`).join('\n')
            }
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6uGcC.default), {
        onDismissed: ()=>setShouldDisplayFlag(false)
    }, shouldDisplayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $29DUH.default), null)));
};

});
parcelRegister("hthDv", function(module, exports) {

$parcel$export(module.exports, "useUpdateNav4OptIn", () => $a132f3d6463ec602$export$b796ceec19d5414c);
/**
 * @graphql cc
 */ 
var $jxs8y = parcelRequire("jxs8y");
var $1KmJq = parcelRequire("1KmJq");

var $d2LG0 = parcelRequire("d2LG0");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $iuIEr = parcelRequire("iuIEr");
const $a132f3d6463ec602$export$b796ceec19d5414c = ({ newIsNav4OptedIn: newIsNav4OptedIn, onCompleted: onCompleted, onError: onError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [nav4OptInSitewideMutation, { data: optInMutationData, loading: optInMutationLoading, error: optInMutationError }] = (0, $1KmJq.useMutation)((0, $d2LG0.default)`mutation useUpdateNav4OptInSitewideMutation($cloudId:ID!$enableNav4:Boolean!){confluence_updateNav4OptIn(cloudId:$cloudId input:{enableNav4:$enableNav4}){success errors{message}}}`);
    const updateNav4OptInSitewide = ()=>nav4OptInSitewideMutation({
            variables: {
                cloudId: cloudId,
                enableNav4: newIsNav4OptedIn
            }
        }).then((updateSiteConfigData)=>{
            const updateSiteConfiguration = updateSiteConfigData?.data?.confluence_updateNav4OptIn;
            if (updateSiteConfiguration?.success) {
                (0, $iuIEr.updateNav4AdminOptInCache)(newIsNav4OptedIn);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'changed',
                        actionSubject: 'navigationVersion',
                        source: 'nav4OptIn',
                        attributes: {
                            originalNavVersion: newIsNav4OptedIn ? '3' : '4',
                            newNavVersion: newIsNav4OptedIn ? '4' : '3'
                        }
                    }
                }).fire();
                onCompleted?.();
            } else // updateSiteConfiguration mutation can return successfully without server errors
            // but have { success: false } in the response. This should be treated as an error
            // as changes were not successfully applied
            handleError(updateSiteConfiguration?.errors);
        }).catch((error)=>{
            handleError(error);
        });
    const [nav4OptInMutation, { data: mutationData, loading: mutationLoading, error: mutationError }] = (0, $1KmJq.useMutation)((0, $d2LG0.default)`mutation useUpdateNav4OptInMutation($siteConfigInput:ConfluenceUpdateSiteConfigurationInput!){confluence{updateSiteConfiguration(input:$siteConfigInput){success errors{message}}}}`);
    const [updateNav4OptIn, { loading: queryLoading, error: queryError }] = (0, $jxs8y.useLazyQuery)((0, $d2LG0.default)`query useUpdateNav4OptInQuery{confluence{siteConfiguration{connectionTimeout formattingSettings{dateFormat dateTimeFormat decimalNumberFormat longNumberFormat timeFormat}globalDefaultLocale{name}indexingLanguage isContactAdministratorsFormEnabled isEditorConversionForSiteEnabled isEditorFullWidthEnabled isEmailNotificationEnabled isExternalConnectionEnabled isLikesEnabled isPushNotificationEnabled attachmentSettings{maxAttachmentSize maxAttachmentsPerUpload}siteHomePage siteTitle socketTimeout}}contactAdminPageConfig{contactAdministratorsMessage}}`, {
        onCompleted: (siteSettingsConfigData)=>{
            nav4OptInMutation({
                variables: {
                    // @ts-ignore
                    siteConfigInput: {
                        isNav4OptedIn: newIsNav4OptedIn,
                        // updateSiteConfiguration mutation has required variables
                        ...$a132f3d6463ec602$var$getRequiredUpdateSiteConfigVariables(siteSettingsConfigData)
                    }
                }
            }).then((updateSiteConfigData)=>{
                const updateSiteConfiguration = updateSiteConfigData?.data?.confluence?.updateSiteConfiguration;
                if (updateSiteConfiguration?.success) {
                    (0, $iuIEr.updateNav4AdminOptInCache)(newIsNav4OptedIn);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'changed',
                            actionSubject: 'navigationVersion',
                            source: 'nav4OptIn',
                            attributes: {
                                originalNavVersion: newIsNav4OptedIn ? '3' : '4',
                                newNavVersion: newIsNav4OptedIn ? '4' : '3'
                            }
                        }
                    }).fire();
                    onCompleted?.();
                } else // updateSiteConfiguration mutation can return successfully without server errors
                // but have { success: false } in the response. This should be treated as an error
                // as changes were not successfully applied
                handleError(updateSiteConfiguration?.errors);
            }).catch((error)=>{
                handleError(error);
            });
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    const handleError = (error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'changeFailed',
                actionSubject: 'navigationVersion',
                source: 'nav4OptIn',
                attributes: {
                    error: error
                }
            }
        }).fire();
        onError?.();
    };
    return {
        updateNav4OptIn: (0, $9wGTI.fg)('confluence_nav_4_update_sitewide_opt_in_mutation') ? updateNav4OptInSitewide : updateNav4OptIn,
        loading: queryLoading || mutationLoading || optInMutationLoading,
        error: queryError || mutationError || optInMutationError,
        isSiteWideUpdateSuccessful: mutationData?.confluence?.updateSiteConfiguration?.success || optInMutationData?.confluence_updateNav4OptIn?.success
    };
};
const $a132f3d6463ec602$var$getRequiredUpdateSiteConfigVariables = (updateSiteConfigData)=>{
    const siteConfiguration = updateSiteConfigData?.confluence?.siteConfiguration;
    const formattingSettings = siteConfiguration?.formattingSettings;
    return {
        connectionTimeout: siteConfiguration?.connectionTimeout,
        customContactMessage: updateSiteConfigData.contactAdminPageConfig.contactAdministratorsMessage || '',
        dateFormat: formattingSettings?.dateFormat,
        dateTimeFormat: formattingSettings?.dateTimeFormat,
        decimalNumberFormat: formattingSettings?.decimalNumberFormat,
        globalDefaultLocale: siteConfiguration?.globalDefaultLocale?.name,
        indexingLanguage: siteConfiguration?.indexingLanguage,
        isContactAdministratorsFormEnabled: siteConfiguration?.isContactAdministratorsFormEnabled,
        isEditorConversionForSiteEnabled: siteConfiguration?.isEditorConversionForSiteEnabled,
        isEditorFullWidthEnabled: siteConfiguration?.isEditorFullWidthEnabled,
        isEmailNotificationEnabled: siteConfiguration?.isEmailNotificationEnabled,
        isExternalConnectionsEnabled: siteConfiguration?.isExternalConnectionEnabled,
        isLikesEnabled: siteConfiguration?.isLikesEnabled,
        isPushNotificationEnabled: siteConfiguration?.isPushNotificationEnabled,
        longNumberFormat: formattingSettings?.longNumberFormat,
        maxAttachmentSize: siteConfiguration?.attachmentSettings?.maxAttachmentSize,
        maxNumberOfAttachmentsPerUpload: siteConfiguration?.attachmentSettings?.maxAttachmentsPerUpload,
        // siteConfiguration query returns null for siteHomePage when no homepage is set,
        // but updateSiteConfiguration mutation requires a string. "Confluence Home" is
        // the default value set on "General configuration" in site settings
        siteHomePage: siteConfiguration?.siteHomePage || 'Confluence Home',
        siteTitle: siteConfiguration?.siteTitle,
        socketTimeout: siteConfiguration?.socketTimeout,
        timeFormat: formattingSettings?.timeFormat
    };
};

});

parcelRegister("b27jz", function(module, exports) {

$parcel$export(module.exports, "useNav4FeedbackCollectorStore", () => $acfe3bc378806851$export$d8a25ad3c2a8c716);
$parcel$export(module.exports, "useNav4FeedbackCollectorActions", () => $acfe3bc378806851$export$a13977ba7a45bade);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $acfe3bc378806851$var$initialState = {
    isOpen: false,
    optingOut: false
};
const $acfe3bc378806851$var$actions = {
    openFeedbackCollector: ()=>({ setState: setState })=>{
            setState({
                isOpen: true,
                optingOut: false
            });
        },
    openOptOutModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: true,
                optingOut: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false,
                optingOut: false
            });
        }
};
const $acfe3bc378806851$var$store = (0, $4ZoIm.createStore)({
    initialState: $acfe3bc378806851$var$initialState,
    actions: $acfe3bc378806851$var$actions,
    name: 'Nav4FeedbackCollectorStore'
});
const $acfe3bc378806851$export$d8a25ad3c2a8c716 = (0, $iFWZA.createHook)($acfe3bc378806851$var$store);
const $acfe3bc378806851$export$a13977ba7a45bade = (0, $iFWZA.createActionsHook)($acfe3bc378806851$var$store);

});


parcelRegister("2WkeQ", function(module, exports) {

$parcel$export(module.exports, "MisalignedNavVersionsFlag", () => $d903e4dac8e596de$export$40ad526e6a3cd784);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7aRa9 = parcelRequire("7aRa9");

var $1ytiN = parcelRequire("1ytiN");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $deyhs = parcelRequire("deyhs");
var $dKIZZ = parcelRequire("dKIZZ");
var $gz8ZY = parcelRequire("gz8ZY");
const $d903e4dac8e596de$export$40ad526e6a3cd784 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownInfoFlag = (0, $e9zUf.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG);
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const { nav4AdminOptedIn: isSiteWideNav4Enabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    /**
   * The user is an admin capable of admin-only opt-out
   * We are in GA phase 1
   * Nav 4 is opted-in at the site level
   * The user is seeing nav 3 due to prior personal preference update
   */ const navVersionsAreMisaligned = (isSiteAdmin || isAdmin) && isSiteWideNav4Enabled && currentGAPhase === 1 && !isNav4DisplayedToUser;
    (0, $gwFzn.useEffect)(()=>{
        if (!hasShownInfoFlag && navVersionsAreMisaligned) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagDescription),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagLink),
                        href: '/wiki/admin/newfeatures'
                    }
                ],
                isAutoDismiss: false
            });
            (0, $e9zUf.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG, 'true');
        }
    }, [
        hasShownInfoFlag,
        navVersionsAreMisaligned,
        flags
    ]);
    return null;
});
const $d903e4dac8e596de$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    misalignedNavVersionsFlagTitle: {
        id: "nav-versions-misaligned.flag",
        defaultMessage: "New navigation is turned on for everyone"
    },
    misalignedNavVersionsFlagDescription: {
        id: "nav-versions-misaligned.flag.description",
        defaultMessage: "You are still on the old navigation because you previously opted out. You can update your navigation preferences in settings."
    },
    misalignedNavVersionsFlagLink: {
        id: "nav-versions-misaligned.flag.link",
        defaultMessage: "Go to settings"
    }
});

});

parcelRegister("koDo7", function(module, exports) {

$parcel$export(module.exports, "TrialPlanComparisonModalMountComponent", () => $8e4a487f1ccf39b0$export$7699251dbf86d265);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $euL71 = parcelRequire("euL71");

var $fcF01 = parcelRequire("fcF01");

const $8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "z7feK",
    name: "LazyExperimentPlanSelectionModal",
    loader: async ()=>(await (parcelRequire("C1N4u"))).ExperimentPlanSelectionModal
});
const $8e4a487f1ccf39b0$export$7699251dbf86d265 = ()=>{
    const { currentEdition: currentEdition } = (0, $gwFzn.useContext)((0, $fcF01.UpFlowContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null));
};

});
parcelRegister("C1N4u", function(module, exports) {

let $0724f0469439cd6f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0724f0469439cd6f$var$load("dj3mE").then(()=>parcelRequire('2pYxO'));

});


parcelRegister("g2WJx", function(module, exports) {

$parcel$export(module.exports, "ModernizeModal", () => $d921da2f70d452da$export$4ac27df6d9f83e0);
// A component that opens the modal when the user is eligible

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $dIouf = parcelRequire("dIouf");

var $3XYLM = parcelRequire("3XYLM");
const $d921da2f70d452da$export$4ac27df6d9f83e0 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION
})(()=>{
    const { isOpen: isOpen, loading: loading, error: error, onClose: onClose, onInteraction: onInteraction } = (0, $3XYLM.useModernizeModal)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    });
    if (loading || !isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d921da2f70d452da$var$LazyModal, {
        onClose: onClose,
        onInteraction: onInteraction
    });
});

const $d921da2f70d452da$var$LazyModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "VCdgX",
    name: "LazyModal",
    loader: async ()=>(await (parcelRequire("grsCj"))).Modal
});

});
parcelRegister("3XYLM", function(module, exports) {

$parcel$export(module.exports, "useModernizeModal", () => $0f6ef52a21b85e2c$export$6ba30750c7a6afda);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $ivb8S = parcelRequire("ivb8S");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $1BYn9 = parcelRequire("1BYn9");

var $gz8ZY = parcelRequire("gz8ZY");

var $dBcar = parcelRequire("dBcar");
const $0f6ef52a21b85e2c$var$isLicensed = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
const $0f6ef52a21b85e2c$var$atLeastTwo = (...features)=>features.reduce((count, feature)=>count + (feature ? 1 : 0), 0) >= 2;
const $0f6ef52a21b85e2c$var$useHasEnoughFeatures = ()=>{
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return $0f6ef52a21b85e2c$var$atLeastTwo((0, $9wGTI.fg)('confluence_frontend_content_wrapper'), (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in'), isNav4Enabled) || isProductAdmin;
};
const $0f6ef52a21b85e2c$export$6ba30750c7a6afda = ()=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(null);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $dBcar.WHATS_NEW_IN_CONFLUENCE)),
        ...Object.values((0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL))
    ], !$0f6ef52a21b85e2c$var$isLicensed(accessStatus) || !(0, $9wGTI.fg)('cc_onboarding_modernize_confluence_ipm_modal'));
    const { hasDismissedModernizeConfluenceIpmModal: hasDismissedModernizeConfluenceIpmModal } = (0, $ivb8S.deserializeState)(data);
    const hasEnoughFeatures = $0f6ef52a21b85e2c$var$useHasEnoughFeatures();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const onInteraction = (0, $gwFzn.useCallback)(()=>{
        if (!hasDismissedModernizeConfluenceIpmModal) setOnboardingState({
            key: (0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL).HAS_DISMISSED_MODAL,
            value: 'true'
        });
    }, [
        setOnboardingState,
        hasDismissedModernizeConfluenceIpmModal
    ]);
    const onClose = ()=>{
        setIsOpen(false);
        onInteraction();
    };
    // Once the onboarding state has loaded for the first time, we mark the modal as open/closed
    // based on the onboarding state.
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen === null && !loading && !error) setIsOpen(!hasDismissedModernizeConfluenceIpmModal);
    }, [
        loading,
        error,
        hasDismissedModernizeConfluenceIpmModal,
        isOpen
    ]);
    if (!(0, $9wGTI.fg)('cc_onboarding_modernize_confluence_ipm_modal')) return {
        isOpen: false,
        onClose: ()=>{},
        onInteraction: ()=>{}
    };
    if (!$0f6ef52a21b85e2c$var$isLicensed(accessStatus)) return {
        isOpen: false,
        onClose: ()=>{},
        onInteraction: ()=>{}
    };
    if (!hasEnoughFeatures) return {
        isOpen: false,
        onClose: ()=>{},
        onInteraction: ()=>{}
    };
    if (error) return {
        isOpen: false,
        error: error,
        onClose: ()=>{},
        onInteraction: ()=>{}
    };
    if (loading) return {
        isOpen: false,
        loading: loading,
        onClose: ()=>{},
        onInteraction: ()=>{}
    };
    return {
        onClose: onClose,
        onInteraction: onInteraction,
        isOpen: isOpen
    };
};

});

parcelRegister("grsCj", function(module, exports) {

let $bf855da933c5a30c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bf855da933c5a30c$var$load("ej4rO"),
    $bf855da933c5a30c$var$load("iZkNL")
]).then(()=>parcelRequire('6vjKX'));

});


parcelRegister("c5zvz", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessUpsellExperiment", () => $ce6cbe4a9370c72f$export$f255ec0f3619af65);
$parcel$export(module.exports, "useConfluenceStandardToPremiumPUBTouchpoint", () => (parcelRequire("fBwOr")).useConfluenceStandardToPremiumPUBTouchpoint);
$parcel$export(module.exports, "StandardToPremiumModalMountComponent", () => (parcelRequire("5DQLv")).StandardToPremiumModalMountComponent);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $5izcQ = parcelRequire("5izcQ");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");


var $fBwOr = parcelRequire("fBwOr");

var $5DQLv = parcelRequire("5DQLv");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce6cbe4a9370c72f$var$Container = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0cglyw _1ydi18uv",
            __cmplp.className
        ])
    });
});

const $ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IlAy6",
    name: "EditionAwarenessUpsellLoadable",
    loader: async ()=>(await (parcelRequire("cyQTn"))).EditionAwarenessUpsell
});
const $ce6cbe4a9370c72f$export$f255ec0f3619af65 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_LUNA
})(({ navVersion: navVersion })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ce6cbe4a9370c72f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable, {
        navVersion: navVersion
    })));
});

});
parcelRegister("fBwOr", function(module, exports) {

$parcel$export(module.exports, "useConfluenceStandardToPremiumPUBTouchpoint", () => $000cc169882182f2$export$70b32605d3b8db81);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $xQxzY = parcelRequire("xQxzY");

var $inPa6 = parcelRequire("inPa6");

var $50xoH = parcelRequire("50xoH");

var $gKr8t = parcelRequire("gKr8t");
var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $99oLS = parcelRequire("99oLS");

var $hxSIT = parcelRequire("hxSIT");

var $aT8im = parcelRequire("aT8im");

var $aURV5 = parcelRequire("aURV5");
const $000cc169882182f2$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    persistentUpgradeMenuItemFreePlanTitle: {
        id: "experiment-edition-awareness-for-standard-to-premium.section.message.persistent-upgrade.menuitem.premiumplan.title",
        defaultMessage: "Upgrade"
    }
});
const $000cc169882182f2$export$70b32605d3b8db81 = (navVersion)=>{
    const [renderFailed, setRenderFailed] = (0, $gwFzn.useState)(false);
    const { cloudId: cloudId, isEligibleForUpsellExperiment: isEligibleForUpsellExperiment, hasDismissedButton: hasDismissedButton } = (0, $aT8im.useConfluenceStandardToPremiumExperiment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal, setModalProps: setModalProps } = (0, $99oLS.useConfluenceStandardToPremiumModalActions)();
    // isEligibleForUpsellExperiment checks for experiment enrollment as well
    const meetsBaseEligibility = isEligibleForUpsellExperiment && hasDismissedButton;
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $aURV5.TenantExperienceUrl), {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId,
            productKey: 'confluence',
            trialOfferingName: 'Premium'
        },
        skip: !meetsBaseEligibility
    });
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'persistent-upgrade-button-standard-to-premium',
                source: 'useConfluenceStandardToPremiumPUBTouchpoint',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion,
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isEligibleForStandardToPremiumPersistentUpgradeButton = meetsBaseEligibility && !renderFailed;
    const experienceUrl = data?.tenantContexts?.[0]?.entitlementInfo?.paidEntitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    if (!loading && isEligibleForStandardToPremiumPersistentUpgradeButton && (!experienceUrl || experienceUrl?.includes('admin/billing'))) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'error',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessStandardToPremiumDialog',
            attributes: {
                product: 'confluence',
                touchpointIntent: 'startTrial',
                dialogId: 'standard-to-premium',
                dialogType: 'modal',
                error: 'No change offering URL found for premium upgrade - using fallback',
                navVersion: navVersion,
                changeOfferingUrl: experienceUrl ?? '',
                isEligibleForStandardToPremiumPersistentUpgradeButton: isEligibleForStandardToPremiumPersistentUpgradeButton
            },
            source: 'useConfluenceStandardToPremiumPUBTouchpoint'
        }
    }).fire();
    // remove the edition from the change plan urls so they land on the plan selection page for hams || ccp
    // there may be a key in shared tenant context api that can be used instead of this
    const learnMoreUrl = (0, $hxSIT.useBuildLearnMoreLink)(experienceUrl);
    const handlePUBClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'persistent-upgrade-button-standard-to-premium',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion
                },
                source: 'useConfluenceStandardToPremiumPUBTouchpoint'
            }
        }).fire();
        setModalProps({
            experienceUrl: experienceUrl ?? '',
            learnMoreUrl: learnMoreUrl,
            navVersion: navVersion
        });
        showModal({
            touchpointId: 'edition-awareness-standard-to-premium-pub'
        });
    }, [
        createAnalyticsEvent,
        showModal,
        setModalProps,
        experienceUrl,
        learnMoreUrl,
        navVersion
    ]);
    if (!isEligibleForStandardToPremiumPersistentUpgradeButton || loading || error) return [];
    return [
        {
            heading: {
                ...$000cc169882182f2$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanTitle
            },
            items: [
                {
                    action: ()=>handlePUBClick(),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
                        attribution: (0, $dIouf.Attribution).GROWTH_LUNA,
                        onError: ()=>setRenderFailed(true)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $50xoH.EditionAwarenessStandardPubTouchpoint), {
                        product: "confluence",
                        testId: "edition-awareness-standard-pub-touchpoint",
                        navVersion: navVersion
                    })),
                    key: 'try-premium-plan'
                }
            ]
        }
    ];
};

});
parcelRegister("50xoH", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessStandardPubTouchpoint", () => $343be00b8c32c969$export$bf5f4133d9c358a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $aIk0I = parcelRequire("aIk0I");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");
const $343be00b8c32c969$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label",
        defaultMessage: "Try the Premium plan"
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge",
        defaultMessage: "FREE 30-DAY TRIAL"
    }
});
const $343be00b8c32c969$var$menuItemContentStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $343be00b8c32c969$var$lozengeContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
        xcss: $343be00b8c32c969$var$menuItemContentStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...$343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $343be00b8c32c969$var$lozengeContainerStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                    appearance: "new",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...$343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment
                    })
                })
            })
        ]
    });
}
function $343be00b8c32c969$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnError = (0, $gwFzn.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl, {
            ...props
        })
    });
}

});
parcelRegister("aIk0I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ed714aba6e968ef3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $3YksS = parcelRequire("3YksS");

var $8bTbx = parcelRequire("8bTbx");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $ed714aba6e968ef3$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>(0, $dh538.fg)('platform_dst_lozenge_fg') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3YksS.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8bTbx.default), {
        ...props
    }));
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$ed714aba6e968ef3$var$Lozenge.displayName = 'Lozenge';
var $ed714aba6e968ef3$export$2e2bcd8739ae039 = $ed714aba6e968ef3$var$Lozenge;

});
parcelRegister("3YksS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d54feba2a694c08a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
const $d54feba2a694c08a$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syaz1gjq",
    'text.subtle.inprogress': "_syaze0os",
    'text.subtle.moved': "_syazwx40",
    'text.subtle.new': "_syazzjem",
    'text.subtle.removed': "_syaz1tmw",
    'text.subtle.success': "_syazy73q"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
const $d54feba2a694c08a$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
const $d54feba2a694c08a$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
}; /**
    * TODO: We should be using our bounded `cssMap` here, but most of
    * these styles from the visual refresh are not in the Design System.
    */ 
const $d54feba2a694c08a$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
const $d54feba2a694c08a$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $d54feba2a694c08a$var$Lozenge = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $gwFzn.useMemo)(()=>$d54feba2a694c08a$var$appearanceTypes.includes(appearance) ? appearance : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $d54feba2a694c08a$var$stylesNew.container,
            $d54feba2a694c08a$var$stylesNew[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && !(0, $dh538.fg)('visual-refresh_drop_5') && $d54feba2a694c08a$var$stylesNew[`border.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $d54feba2a694c08a$var$stylesNew[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $d54feba2a694c08a$var$stylesNew.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $35pXk.default)([
                $d54feba2a694c08a$var$stylesNew.text,
                (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $d54feba2a694c08a$var$stylesNew.customLetterspacing,
                $d54feba2a694c08a$var$stylesNew[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "span",
        backgroundColor: $d54feba2a694c08a$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $d54feba2a694c08a$var$stylesOld.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $35pXk.default)([
                $d54feba2a694c08a$var$stylesOldUnbounded.text,
                (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $d54feba2a694c08a$var$stylesOldUnbounded.customLetterspacing,
                $d54feba2a694c08a$var$stylesOld[`text.${appearanceStyle}.${appearanceType}`]
            ]),
            children: children
        })
    });
});
$d54feba2a694c08a$var$Lozenge.displayName = 'Lozenge';
var $d54feba2a694c08a$export$2e2bcd8739ae039 = $d54feba2a694c08a$var$Lozenge;

});

parcelRegister("8bTbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a62df7e22140fc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $c5a62df7e22140fc$var$baseStylesOld = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $c5a62df7e22140fc$var$styles = {
    container: (0, $3jLHL.css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        position: 'static',
        blockSize: 'min-content',
        borderRadius: '3px',
        overflow: 'hidden',
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $3jLHL.css)({
                backgroundColor: '#DDDEE1'
            }),
            inprogress: (0, $3jLHL.css)({
                backgroundColor: '#8FB8F6'
            }),
            moved: (0, $3jLHL.css)({
                backgroundColor: '#F9C84E'
            }),
            new: (0, $3jLHL.css)({
                backgroundColor: '#D8A0F7'
            }),
            removed: (0, $3jLHL.css)({
                backgroundColor: '#FD9891'
            }),
            success: (0, $3jLHL.css)({
                backgroundColor: '#B3DF72'
            })
        },
        subtle: {
            default: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $3jLHL.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: (0, $3jLHL.css)({
                border: `1px solid #669DF1`
            }),
            moved: (0, $3jLHL.css)({
                border: `1px solid #FCA700`
            }),
            new: (0, $3jLHL.css)({
                border: `1px solid #C97CF4`
            }),
            removed: (0, $3jLHL.css)({
                border: `1px solid #F87168`
            }),
            success: (0, $3jLHL.css)({
                border: `1px solid #94C748`
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $3jLHL.css)({
                outline: `1px solid #B7B9BE`
            }),
            inprogress: (0, $3jLHL.css)({
                outline: `1px solid #669DF1`
            }),
            moved: (0, $3jLHL.css)({
                outline: `1px solid #FCA700`
            }),
            new: (0, $3jLHL.css)({
                outline: `1px solid #C97CF4`
            }),
            removed: (0, $3jLHL.css)({
                outline: `1px solid #F87168`
            }),
            success: (0, $3jLHL.css)({
                outline: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: (0, $3jLHL.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $3jLHL.css)({
            color: '#292A2E'
        })
    }
};
const $c5a62df7e22140fc$var$textStyles = (0, $3jLHL.css)({
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
});
const $c5a62df7e22140fc$var$customLetterspacingStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: 0.165
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $c5a62df7e22140fc$var$Lozenge = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $c5a62df7e22140fc$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $c5a62df7e22140fc$var$styles.container,
            $c5a62df7e22140fc$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $dh538.fg)('visual-refresh_drop_5') && $c5a62df7e22140fc$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $c5a62df7e22140fc$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $c5a62df7e22140fc$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            $c5a62df7e22140fc$var$textStyles,
            (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $c5a62df7e22140fc$var$customLetterspacingStyles,
            $c5a62df7e22140fc$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $c5a62df7e22140fc$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        as: "span",
        backgroundColor: $c5a62df7e22140fc$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $c5a62df7e22140fc$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            $c5a62df7e22140fc$var$textStyles,
            (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $c5a62df7e22140fc$var$customLetterspacingStyles,
            $c5a62df7e22140fc$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$c5a62df7e22140fc$var$Lozenge.displayName = 'Lozenge';
var $c5a62df7e22140fc$export$2e2bcd8739ae039 = $c5a62df7e22140fc$var$Lozenge;
const $c5a62df7e22140fc$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $c5a62df7e22140fc$var$textColorsOld = {
    bold: {
        default: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $3jLHL.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $3jLHL.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $3jLHL.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $3jLHL.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $3jLHL.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $3jLHL.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $3jLHL.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};

});



parcelRegister("99oLS", function(module, exports) {

$parcel$export(module.exports, "useConfluenceStandardToPremiumModalActions", () => $9968f6026062a518$export$d912d1373319011f);
$parcel$export(module.exports, "useConfluenceStandardToPremiumModal", () => $9968f6026062a518$export$cd5aa218e504e6f3);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $9968f6026062a518$var$initialState = {
    isOpen: false,
    learnMoreUrl: '',
    experienceUrl: '',
    navVersion: undefined
};
const $9968f6026062a518$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        },
    setModalProps: ({ learnMoreUrl: learnMoreUrl, experienceUrl: experienceUrl, navVersion: navVersion })=>({ setState: setState })=>{
            setState({
                learnMoreUrl: learnMoreUrl,
                experienceUrl: experienceUrl,
                navVersion: navVersion
            });
        }
};
const $9968f6026062a518$var$store = (0, $4ZoIm.createStore)({
    initialState: $9968f6026062a518$var$initialState,
    actions: $9968f6026062a518$var$actions,
    name: 'editionAwarenessStandardToPremiumModalStore'
});
const $9968f6026062a518$export$d912d1373319011f = (0, $iFWZA.createActionsHook)($9968f6026062a518$var$store);
const $9968f6026062a518$export$cd5aa218e504e6f3 = (0, $iFWZA.createHook)($9968f6026062a518$var$store);

});

parcelRegister("hxSIT", function(module, exports) {

$parcel$export(module.exports, "useBuildLearnMoreLink", () => $8c4b8f8f76d4beac$export$9bcf733c7567f1c);

var $gwFzn = parcelRequire("gwFzn");
const $8c4b8f8f76d4beac$export$9bcf733c7567f1c = (baseUrl)=>{
    const FALLBACK_URL = '/admin/billing';
    return (0, $gwFzn.useMemo)(()=>{
        if (!baseUrl) return FALLBACK_URL;
        try {
            const url = new URL(baseUrl);
            const isHams = url.pathname.includes('change-edition');
            if (isHams) // remove "/<edition>" at the end of the path
            url.pathname = url.pathname.split('/').slice(0, -1).join('/');
            else {
                url.searchParams.delete('offeringName');
                url.searchParams.delete('offeringname');
            }
            return url.toString();
        } catch (err) {
            return FALLBACK_URL;
        }
    }, [
        baseUrl
    ]);
};

});

parcelRegister("aT8im", function(module, exports) {

$parcel$export(module.exports, "EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED", () => $318f5483656bcff4$export$cf07606bc08d56a7);
$parcel$export(module.exports, "useConfluenceStandardToPremiumExperimentQuery", () => $318f5483656bcff4$export$22acf73b61314d4f);
$parcel$export(module.exports, "useConfluenceStandardToPremiumExperiment", () => $318f5483656bcff4$export$f2e766b4a1af4c38);

var $j1Ss3 = parcelRequire("j1Ss3");

var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $inPa6 = parcelRequire("inPa6");

var $7Sm4c = parcelRequire("7Sm4c");

var $ivb8S = parcelRequire("ivb8S");

var $6mKj3 = parcelRequire("6mKj3");

var $bQm3c = parcelRequire("bQm3c");

var $2Q7EG = parcelRequire("2Q7EG");
const $318f5483656bcff4$export$cf07606bc08d56a7 = 'growth-luna-edition-awareness-standard-to-premium:treatmentPillDismissed';
const $318f5483656bcff4$export$22acf73b61314d4f = (0, $d2LG0.default)`query useConfluenceStandardToPremiumExperimentQuery($key:[String]){isSiteAdmin onboardingState(key:$key){key value}license{trialEndDate}}`;
const $318f5483656bcff4$export$f2e766b4a1af4c38 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)($318f5483656bcff4$export$22acf73b61314d4f, {
        variables: {
            key: $318f5483656bcff4$export$cf07606bc08d56a7
        },
        fetchPolicy: 'cache-only'
    });
    const { edition: confluenceEdition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const handleDismiss = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: $318f5483656bcff4$export$cf07606bc08d56a7,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'ea-standard-to-premium-query',
                source: 'useConfluenceStandardToPremiumExperiment',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    // Exposure fired earlier in experiment when they see EA
    const enrolled = (0, $6mKj3.expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'control') || (0, $6mKj3.expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'treatment');
    const isSiteAdmin = data?.isSiteAdmin;
    const edition = confluenceEdition?.toLocaleLowerCase();
    const trialEndDate = data?.license?.trialEndDate;
    const trialDaysLeft = (0, $2Q7EG.getTrialDaysLeft)(trialEndDate);
    const isInTrial = !data || loading || error ? undefined : trialDaysLeft ? trialDaysLeft > 0 : false;
    const { treatmentPillDismissed: treatmentPillDismissed } = (0, $ivb8S.deserializeState)(data?.onboardingState ? {
        onboardingState: data?.onboardingState
    } : null);
    const isDismissed = loading || !!error || !!treatmentPillDismissed;
    const isEligibleForUpsellExperiment = enrolled && edition === 'standard' && isInTrial === false && !!isSiteAdmin;
    return {
        isEligibleForUpsellExperiment: isEligibleForUpsellExperiment,
        cloudId: cloudId,
        product: 'confluence',
        edition: edition,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        hasDismissedButton: isDismissed,
        onDismissButton: handleDismiss
    };
};

});
parcelRegister("2Q7EG", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $eea3be158b3f7463$export$954628993bf3188e);

var $5PE1K = parcelRequire("5PE1K");
const $eea3be158b3f7463$export$666163d445f1868a = (queryData)=>{
    const trialEndDate = queryData?.license?.trialEndDate;
    return $eea3be158b3f7463$export$954628993bf3188e(trialEndDate);
};
const $eea3be158b3f7463$export$954628993bf3188e = (trialEndDate)=>{
    if (!trialEndDate) return null;
    // +1 day to round up for fractional days
    return (0, $5PE1K.default)(new Date(trialEndDate), new Date()) + 1;
};

});


parcelRegister("aURV5", function(module, exports) {

$parcel$export(module.exports, "TenantExperienceUrl", () => $7ec7410ac39f2d12$export$8a518b076d713fb1);

var $d2LG0 = parcelRequire("d2LG0");
const $7ec7410ac39f2d12$export$8a518b076d713fb1 = (0, $d2LG0.default)`query confluenceEditionAwarenessQuery($cloudId:ID!$productKey:String!$trialOfferingName:String!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:$productKey){paidEntitlement:entitlement(where:{inTrialOrPreDunning:false}){experienceCapabilities{changeOfferingV2(offeringName:$trialOfferingName){experienceUrl}}}}}}`;

});


parcelRegister("5DQLv", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumModalMountComponent", () => $cf9f6e6dcd5627ce$export$4b9ed4d06294662c);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $jmjWc = parcelRequire("jmjWc");

const $cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xlut2",
    name: "LazyStandardToPremiumModal",
    loader: async ()=>(await (parcelRequire("6YOkL"))).StandardToPremiumModal
});
const $cf9f6e6dcd5627ce$export$4b9ed4d06294662c = ()=>{
    if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal, null);
    return null;
};

});
parcelRegister("6YOkL", function(module, exports) {

let $514f63e9f345edab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $514f63e9f345edab$var$load("6Btng"),
    $514f63e9f345edab$var$load("9CRBg")
]).then(()=>parcelRequire('hCU0r'));

});


parcelRegister("cyQTn", function(module, exports) {

let $9251b04e5ff67192$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9251b04e5ff67192$var$load("7AHh3"),
    $9251b04e5ff67192$var$load("5a0ic"),
    $9251b04e5ff67192$var$load("dGLrg"),
    $9251b04e5ff67192$var$load("cC8RD"),
    $9251b04e5ff67192$var$load("eufZR"),
    $9251b04e5ff67192$var$load("aZinD"),
    $9251b04e5ff67192$var$load("6zfzy"),
    $9251b04e5ff67192$var$load("6qah4"),
    $9251b04e5ff67192$var$load("lz2pE")
]).then(()=>parcelRequire('7Bwbp'));

});


parcelRegister("liCZ6", function(module, exports) {

$parcel$export(module.exports, "ModernizeChangeboarding", () => $0cafdf8f81e44cdc$export$51c4358102159001);
$parcel$export(module.exports, "useModernizeChangeboardingActive", () => (parcelRequire("bgTcf")).useModernizeChangeboardingActive);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $jmjWc = parcelRequire("jmjWc");

var $bgTcf = parcelRequire("bgTcf");

const $0cafdf8f81e44cdc$var$ModernizeChangeboardingLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "HOLxR",
    name: "ModernizeChangeboardingLoadable",
    loader: async ()=>(await (parcelRequire("4bCbj"))).ModernizeChangeboarding
});
const $0cafdf8f81e44cdc$export$51c4358102159001 = ()=>{
    return (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0cafdf8f81e44cdc$var$ModernizeChangeboardingLoadable, null) : null;
};

});
parcelRegister("bgTcf", function(module, exports) {

$parcel$export(module.exports, "useModernizeChangeboardingActive", () => $cd6b8aafecf555f5$export$6f50ba18fc24265e);
$parcel$export(module.exports, "useModernizeChangeboardingState", () => $cd6b8aafecf555f5$export$8f3ba153b8f179a7);
$parcel$export(module.exports, "WithModernizeChangeboardingActive", () => $cd6b8aafecf555f5$export$e6009f28c745ed28);
$parcel$export(module.exports, "WithModernizeNav4GlobalChangeboardingActive", () => $cd6b8aafecf555f5$export$7ebbacbc785c02ee);
$parcel$export(module.exports, "WithModernizeNav4SpaceSettingsChangeboardingActive", () => $cd6b8aafecf555f5$export$9955699a3aa2b6fa);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $4u5NT = parcelRequire("4u5NT");

var $9wGTI = parcelRequire("9wGTI");
const $cd6b8aafecf555f5$var$initialState = {
    active: false,
    nav4GlobalChangeboardingActive: false,
    nav4SpaceSettingsChangeboardingActive: false
};
const $cd6b8aafecf555f5$var$actions = {
    setActive: (active)=>({ setState: setState })=>{
            setState({
                active: active
            });
        },
    nav4GlobalChangeboardingActive: (nav4GlobalChangeboardingActive)=>({ setState: setState })=>{
            setState({
                nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive
            });
        },
    nav4SpaceSettingsChangeboardingActive: (nav4SpaceSettingsChangeboardingActive)=>({ setState: setState })=>{
            setState({
                nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive
            });
        }
};
const $cd6b8aafecf555f5$var$ModernizeChangeboardingStore = (0, $4ZoIm.createStore)({
    initialState: $cd6b8aafecf555f5$var$initialState,
    actions: $cd6b8aafecf555f5$var$actions
});
const $cd6b8aafecf555f5$export$6f50ba18fc24265e = (0, $iFWZA.createStateHook)($cd6b8aafecf555f5$var$ModernizeChangeboardingStore, {
    selector: (state)=>state.active
});
const $cd6b8aafecf555f5$export$8f3ba153b8f179a7 = (0, $iFWZA.createStateHook)($cd6b8aafecf555f5$var$ModernizeChangeboardingStore);
const $cd6b8aafecf555f5$var$useActions = (0, $iFWZA.createActionsHook)($cd6b8aafecf555f5$var$ModernizeChangeboardingStore);
const $cd6b8aafecf555f5$var$WithModernizeChangeboardingActiveComponent = ({ children: children, setActive: setActive })=>{
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_exclude_changeboarding_from_vc')) (0, $4u5NT.abortAll)('new_interaction', 'modernize-changeboarding');
        setActive(true);
        return ()=>{
            setActive(false);
        };
    }, [
        setActive
    ]);
    return children;
};
const $cd6b8aafecf555f5$export$e6009f28c745ed28 = ({ children: children })=>{
    const { setActive: setActive } = $cd6b8aafecf555f5$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($cd6b8aafecf555f5$var$WithModernizeChangeboardingActiveComponent, {
        setActive: setActive
    }, children);
};
const $cd6b8aafecf555f5$export$7ebbacbc785c02ee = ({ children: children })=>{
    const { nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive } = $cd6b8aafecf555f5$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($cd6b8aafecf555f5$var$WithModernizeChangeboardingActiveComponent, {
        setActive: nav4GlobalChangeboardingActive
    }, children);
};
const $cd6b8aafecf555f5$export$9955699a3aa2b6fa = ({ children: children })=>{
    const { nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive } = $cd6b8aafecf555f5$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($cd6b8aafecf555f5$var$WithModernizeChangeboardingActiveComponent, {
        setActive: nav4SpaceSettingsChangeboardingActive
    }, children);
};

});

parcelRegister("4bCbj", function(module, exports) {

let $30c5ce87d1b364d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $30c5ce87d1b364d6$var$load("gmwfN").then(()=>parcelRequire('53kS0'));

});



parcelRegister("1DHa6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b62a238333cef43f$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");

var $5KDDn = parcelRequire("5KDDn");

var $dh538 = parcelRequire("dh538");

var $804cB = parcelRequire("804cB");

var $6ucq4 = parcelRequire("6ucq4");

var $es389 = parcelRequire("es389");
const $b62a238333cef43f$var$bodyStyles = null;
const $b62a238333cef43f$var$fontStyles = null; /**
                          * Adding the padding here avoids cropping the keyline on its sides.
                          * The combined vertical spacing is maintained by subtracting the
                          * keyline height from header and footer using negative margins.
                          */ 
const $b62a238333cef43f$var$bodyScrollStyles = null; /**
                                * Keylines will not be shown if scrolling in viewport so we do
                                * not account for them in this case.
                                */ 
const $b62a238333cef43f$var$viewportScrollStyles = null;
const $b62a238333cef43f$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const shouldScrollInViewport = (0, $es389.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            "_18zr1ejb",
            (0, $dh538.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5KDDn.TouchScrollable), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ucq4.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                "data-testid": testId,
                className: (0, $35pXk.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug",
                    "_1rjc1bk5 _18zr1ejb",
                    (0, $dh538.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
                ]),
                children: children
            })
        })
    });
};
var $b62a238333cef43f$export$2e2bcd8739ae039 = $b62a238333cef43f$var$ModalBody;

});
parcelRegister("804cB", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $f5cb14e7ec743f95$export$33ffd74ebf07f060);

var $gwFzn = parcelRequire("gwFzn");

var $dbEzH = parcelRequire("dbEzH");
const $f5cb14e7ec743f95$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $gwFzn.useContext)((0, $dbEzH.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("6ucq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8b4794e6938131$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $2ZsRZ = parcelRequire("2ZsRZ");

var $3654r = parcelRequire("3654r");

var $ee7An = parcelRequire("ee7An");

var $aCLu8 = parcelRequire("aCLu8");

var $dOMrE = parcelRequire("dOMrE");
const $0f8b4794e6938131$var$keylineColor = "var(--ds-border, #091E4224)";
const $0f8b4794e6938131$var$baseStyles = null;
const $0f8b4794e6938131$var$keylineHeight = 2;
const $0f8b4794e6938131$var$topKeylineStyles = null;
const $0f8b4794e6938131$var$bottomKeylineStyles = null;
const $0f8b4794e6938131$var$ScrollContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $gwFzn.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $gwFzn.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $gwFzn.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $gwFzn.useState)(false); // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $gwFzn.useEffect)(()=>{
        const schedule = (0, $2ZsRZ.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $aCLu8.default)((0, $2ZsRZ.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $0f8b4794e6938131$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $0f8b4794e6938131$var$keylineHeight);
        }
    })); // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $gwFzn.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $d8F95.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $d8F95.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $ee7An.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dOMrE.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div" // tabindex is allowed here so that keyboard users can scroll content
        , {
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? 'Scrollable content' : undefined,
            "data-testid": testId && `${testId}--scrollable`,
            ref: (0, $3654r.default)([
                ref,
                scrollableRef
            ]),
            className: (0, $35pXk.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
                showTopKeyline && "_mqm2v2xi",
                showBottomKeyline && "_179rv2xi"
            ]),
            children: children
        })
    });
});
$0f8b4794e6938131$var$ScrollContainer.displayName = 'ScrollContainer';
var $0f8b4794e6938131$export$2e2bcd8739ae039 = $0f8b4794e6938131$var$ScrollContainer;

});

parcelRegister("es389", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a89e0d55be82e39$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $dbEzH = parcelRequire("dbEzH");
function $3a89e0d55be82e39$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $gwFzn.useContext)((0, $dbEzH.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("8o1lj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $946150c7df517ac0$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $804cB = parcelRequire("804cB");
const $946150c7df517ac0$var$footerStyles = null;
const $946150c7df517ac0$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1ezb _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $946150c7df517ac0$export$2e2bcd8739ae039 = $946150c7df517ac0$var$ModalFooter;

});

parcelRegister("9ot3w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $675b4731f49c3b03$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $8TTLA = parcelRequire("8TTLA");

var $804cB = parcelRequire("804cB");
const $675b4731f49c3b03$var$headerStyles = null;
const $675b4731f49c3b03$var$flexStyles = (0, $ecnYn.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $675b4731f49c3b03$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`; // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1ezb _85i5pxbi _1q511ejb"
        ]),
        children: shouldShowCloseButton ? // The reason we are putting the close button first in the DOM and then
        // reordering them is to ensure that users of assistive technology get
        // all the context of a modal when initial focus is placed on the close
        // button, since it's the first interactive element.
        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $675b4731f49c3b03$var$flexStyles,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8TTLA.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    children: children
                })
            ]
        }) : children
    });
};
var $675b4731f49c3b03$export$2e2bcd8739ae039 = $675b4731f49c3b03$var$ModalHeader;

});
parcelRegister("8TTLA", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $5924532aef146558$export$de65de8213222d10);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");

var $1jfCH = parcelRequire("1jfCH");
const $5924532aef146558$export$de65de8213222d10 = ({ label: label, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jfCH))),
        label: label || 'Close Modal',
        onClick: onClick
    });

});


parcelRegister("195qZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d5ad8d603a22871$var$_react = $0d5ad8d603a22871$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0d5ad8d603a22871$var$_questionCircle = $0d5ad8d603a22871$var$_interopRequireDefault((parcelRequire("ci7Ox")));

var $0d5ad8d603a22871$var$_questionCircle2 = $0d5ad8d603a22871$var$_interopRequireDefault((parcelRequire("8nVd9")));
function $0d5ad8d603a22871$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d5ad8d603a22871$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $0d5ad8d603a22871$var$_react.default.createElement($0d5ad8d603a22871$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $0d5ad8d603a22871$var$_questionCircle2.default
    }, props));
$0d5ad8d603a22871$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $0d5ad8d603a22871$var$_default = module.exports.default = $0d5ad8d603a22871$var$QuestionCircleIcon;

});
parcelRegister("ci7Ox", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f2d3a379cb5e0d2$var$_react = $8f2d3a379cb5e0d2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8f2d3a379cb5e0d2$var$_baseNew = $8f2d3a379cb5e0d2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f2d3a379cb5e0d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f2d3a379cb5e0d2$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8f2d3a379cb5e0d2$var$_react.default.createElement($8f2d3a379cb5e0d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$8f2d3a379cb5e0d2$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $8f2d3a379cb5e0d2$var$_default = module.exports.default = $8f2d3a379cb5e0d2$var$QuestionCircleIcon;

});

parcelRegister("8nVd9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61acd9aba8d3263b$var$_react = $61acd9aba8d3263b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $61acd9aba8d3263b$var$_questionCircle = $61acd9aba8d3263b$var$_interopRequireDefault((parcelRequire("ci7Ox")));
function $61acd9aba8d3263b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61acd9aba8d3263b$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $61acd9aba8d3263b$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $61acd9aba8d3263b$var$_questionCircle.default
    }));
$61acd9aba8d3263b$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $61acd9aba8d3263b$var$_default = module.exports.default = $61acd9aba8d3263b$var$QuestionCircleIcon;

});


parcelRegister("eZFA1", function(module, exports) {

$parcel$export(module.exports, "GrantAccessDialogLoaderQuery", () => $4ab52410a046c365$export$1cf432ea3a028ecc);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $4ab52410a046c365$export$1cf432ea3a028ecc = (0, $d2LG0.default)`query GrantAccessDialogLoaderQuery($contentId:ID!$accountId:ID!){singleContent(id:$contentId){id title}user:confluence_atlassianUser(id:$accountId){id displayName photos{value isPrimary}}}`;

});

parcelRegister("d6Fdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $29781e74b331cae7$export$2e2bcd8739ae039);
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $29781e74b331cae7$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $29781e74b331cae7$var$svgStyles = null; /**
                         * __SVG__
                         *
                         * An icon is used as a visual representation of common actions and commands to provide context.
                         *
                         * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
                         * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
                         */ 
const $29781e74b331cae7$var$SVG = /*#__PURE__*/ (0, $gwFzn.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $29781e74b331cae7$var$sizeStyles[size]
        ]),
        children: children
    });
});
var $29781e74b331cae7$export$2e2bcd8739ae039 = $29781e74b331cae7$var$SVG;

});

parcelRegister("jIOyV", function(module, exports) {

$parcel$export(module.exports, "MORE_ACTIONS_DROPDOWN_INTERACTION", () => $4fa41f80373a2ebe$export$f49429c67898bd15);
$parcel$export(module.exports, "MOVE_PAGE_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$daaf73616fe91ce9);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$d4222bce9029f393);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION", () => $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$eb06363d6ef3b8dd);
$parcel$export(module.exports, "QUICK_SUMMARY_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$ef2fb65c026ab7d3);
$parcel$export(module.exports, "OPEN_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$8122cf0ca2968a7b);
$parcel$export(module.exports, "INITIALIZE_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$ea9696a28a6fbc61);
$parcel$export(module.exports, "COMMENTS_SUMMARY_COMPONENT_INTERACTION", () => $4fa41f80373a2ebe$export$e561726b92a6162d);
$parcel$export(module.exports, "CREATE_SPACE_DRAWER_INTERACTION", () => $4fa41f80373a2ebe$export$e348981755bdab67);
$parcel$export(module.exports, "VIEW_AI_PRESENTATION_INTERACTION", () => $4fa41f80373a2ebe$export$af1eb8557193d022);
$parcel$export(module.exports, "AI_CONTENT_CATCHUP_INTERACTION", () => $4fa41f80373a2ebe$export$7f72b8ffbbbfef58);
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';

});

parcelRegister("bVAxT", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogStateContainer", () => $20c3e8ab10e63e24$export$f91385b453474810);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");
class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $ipPpS.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}

});

parcelRegister("b1HmN", function(module, exports) {

$parcel$export(module.exports, "LoadableChangeEditionNotificationDialog", () => $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6);

var $jmjWc = parcelRequire("jmjWc");

const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("2uk7P"))).ChangeEditionNotificationDialog
});

});
parcelRegister("2uk7P", function(module, exports) {

let $1cfdfe909af8de2b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1cfdfe909af8de2b$var$load("kSVGa").then(()=>parcelRequire('5BDEU'));

});


parcelRegister("5u6LZ", function(module, exports) {

$parcel$export(module.exports, "GrantAccessDialogLoader", () => $11d9bf397902be9d$export$238288686fd365c4);
/**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $eZFA1 = parcelRequire("eZFA1");

const $11d9bf397902be9d$export$cc070c4b76bfe85d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5ag_g",
    name: "GrantAccessDialogPaint",
    loader: async ()=>(await (parcelRequire("82WSo"))).GrantAccessDialog
});

const $11d9bf397902be9d$export$238288686fd365c4 = ({ contentId: contentId, accountId: accountId, shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions, buttonPlaceholder: buttonPlaceholder, ...props })=>{
    const GrantAccessDialog = (0, $jmjWc.LoadableLazy)({
        __loadable_id__: "o997N",
        name: "GrantAccessDialog",
        loader: async ()=>(await (parcelRequire("82WSo"))).GrantAccessDialog,
        loading: ()=>buttonPlaceholder
    });
    const shouldPreloadGrantAccess = shouldSSRGrantAccessRestrictions && window.__SSR_RENDERED__;
    const { data: data, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $eZFA1.GrantAccessDialogLoaderQuery), {
        variables: {
            contentId: contentId || '',
            accountId: accountId
        },
        skip: !contentId || !accountId,
        fetchPolicy: shouldPreloadGrantAccess ? 'cache-first' : 'cache-and-network'
    });
    let profilePhoto = '';
    const photos = data?.user?.photos;
    if (photos?.length) {
        const primary = photos.find((photo)=>photo?.isPrimary);
        const foundPhoto = primary ? primary.value : photos[0]?.value;
        profilePhoto = foundPhoto || '';
    }
    const Component = shouldSSRGrantAccessRestrictions ? $11d9bf397902be9d$export$cc070c4b76bfe85d : GrantAccessDialog;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    });
    else if (!contentId || !data?.user) // If user is not recognized or we have no target contentId, render just the children.
    // User is identified via URL params and it would be easy to pass invalid data.
    // Note: must render the children, as this is how restrictions button is displayed
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
        contentId: contentId,
        accountId: accountId,
        contentTitle: data?.singleContent?.title || '',
        displayName: data?.user?.displayName || '',
        profilePhoto: profilePhoto,
        ...props
    });
};

});
parcelRegister("82WSo", function(module, exports) {

let $5dbc2e39f3f76c10$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5dbc2e39f3f76c10$var$load("h4Nf7"),
    $5dbc2e39f3f76c10$var$load("aZinD"),
    $5dbc2e39f3f76c10$var$load("f96v0"),
    $5dbc2e39f3f76c10$var$load("ev7SX"),
    $5dbc2e39f3f76c10$var$load("5tHTv"),
    $5dbc2e39f3f76c10$var$load("c6MKV"),
    $5dbc2e39f3f76c10$var$load("4fCJZ"),
    $5dbc2e39f3f76c10$var$load("4aLlP"),
    $5dbc2e39f3f76c10$var$load("9PeA0")
]).then(()=>parcelRequire('3aGPB'));

});


parcelRegister("8RR7m", function(module, exports) {

$parcel$export(module.exports, "GrantAccessFlagLoader", () => $1756d5d44ec15fad$export$a83249587a24be5);

var $jmjWc = parcelRequire("jmjWc");

const $1756d5d44ec15fad$export$a83249587a24be5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "960Da",
    name: "GrantAccessFlagLoader",
    loader: async ()=>(await (parcelRequire("Ja0U0"))).GrantAccessFlag
});

});
parcelRegister("Ja0U0", function(module, exports) {

let $087bf891360ed6a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $087bf891360ed6a1$var$load("h4Nf7"),
    $087bf891360ed6a1$var$load("aZinD"),
    $087bf891360ed6a1$var$load("f96v0"),
    $087bf891360ed6a1$var$load("ev7SX"),
    $087bf891360ed6a1$var$load("5tHTv"),
    $087bf891360ed6a1$var$load("c6MKV"),
    $087bf891360ed6a1$var$load("4fCJZ"),
    $087bf891360ed6a1$var$load("4aLlP"),
    $087bf891360ed6a1$var$load("4mWJk")
]).then(()=>parcelRequire('4Cd45'));

});


parcelRegister("14SPd", function(module, exports) {

$parcel$export(module.exports, "RESTRICTIONS_BUTTON_METRIC", () => $8ab24ab9418ac89d$export$34cc51d2a4e5cf67);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_METRIC", () => $8ab24ab9418ac89d$export$2ba38536ff91e2a7);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
var $jIOyV = parcelRequire("jIOyV");
const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});

});

parcelRegister("cSVAY", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonLoaderPaint", () => $c09757da0c891efc$export$758fc7bfe6cba448);
$parcel$export(module.exports, "RestrictionsButtonLoaderAfterPaint", () => $c09757da0c891efc$export$92f59ae572209281);

var $jmjWc = parcelRequire("jmjWc");

var $eE3dj = parcelRequire("eE3dj");

var $fkOJz = parcelRequire("fkOJz");

const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("9WDNr"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("9WDNr"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});

});
parcelRegister("eE3dj", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonPlaceholder", () => $cb1652ec96a3881c$export$f7c9f842c83767d4);

var $gwFzn = parcelRequire("gwFzn");
function $cb1652ec96a3881c$export$f7c9f842c83767d4() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
}

});

parcelRegister("fkOJz", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonLoading", () => $560660f3777cb1ae$export$3375d726052961a6);

var $gwFzn = parcelRequire("gwFzn");

var $j8UzL = parcelRequire("j8UzL");

var $eE3dj = parcelRequire("eE3dj");
const $560660f3777cb1ae$var$checkForSSRRestrictionsButtonClicked = ()=>{
    return Boolean(window.__SSR_EVENTS_CAPTURE__?.restrictionsButton);
};
const $560660f3777cb1ae$export$3375d726052961a6 = ()=>{
    return $560660f3777cb1ae$var$checkForSSRRestrictionsButtonClicked() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j8UzL.SSRActionLoadingSpinner), {
        spinnerId: "restrictions-loading-spinner",
        actionType: "restrictionsButton"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};

});

parcelRegister("9WDNr", function(module, exports) {

let $73d8669703d89938$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $73d8669703d89938$var$load("bfhXH").then(()=>parcelRequire('l5Yc7'));

});



//# sourceMappingURL=GlobalComponents.b1712ff0.js.map
